import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Pagination,
  Tabs,
  Tab,
  TextField,
  Chip,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import ReusableTable from "../../component/ui/ReusableTable";
import { saveAs } from "file-saver";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/Booking.scss";
import "../../styles/UserStyles.css";
import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";
import {
  formatDateWithAmPm,
  formatDateWithAmPmBooking,
  getStatusClass,
} from "../../Style";
import {
  BOOKING_AIRPORT_DETAILS,
  EDIT_BOOKINGS,
  VIEW_BOOKINGS,
} from "../../component/common/Routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import {
  VENDOR_BOOKING_AIRPORT_DETAILS,
  VENDOR_EDIT_BOOKINGS,
  VENDOR_VIEW_BOOKINGS,
} from "../../component/common/Routes/VendorRoutes";
import {
  CUSTOMER_BOOKING_AIRPORT_DETAILS,
  CUSTOMER_VIEW_BOOKINGS,
} from "../../component/common/Routes/CustomerRoutes";
import {
  fetchBookingsRequest,
  deleteBookingRequest,
  fetchCustomerBookingsRequest,
  resetBookingDetails,
  fetchComplementaryBookingsRequest,
  fetchInstantBookingsRequest,
  getAllBookingsRequest,
  fetchAllBookingRequest,
  resendRazorpayLinkRequest,
  resendRazorpayLinkReset,
  updatePaymentStatusReset,
  updatePaymentStatusRequest,
  updateBookingStatusReset,
  updateBookingStatusRequest,
} from "../../redux/Bookings/BookingAction";

import CustomButton from "../../component/ui/FormFields/Button";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../component/ui/Loading";
import nodata from "../../assets/nodata.jpg";
import axiosInstance from "../../redux/instance/AxiosInstance";
import PaymentStatusDialog from "./PaymentStatusDialog";

const BookingList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const bookings = useSelector((state) => state.booking.bookings || []);

  const [updatePaymentDialogOpen, setUpdatePaymentDialogOpen] = useState(false);
  const [updateBookingDialogOpen, setUpdateBookingDialogOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("1");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [bookingStatus, setBookingStatus] = useState("1");

  const bookingsForExport = useSelector(
    (state) => state.booking.bookingsForExport || []
  );

  const totalRecord = useSelector((state) => state.booking?.totalRecords || []);
  const totalPages = useSelector((state) => state.booking?.totalPages || []);
  const deleteSuccess = useSelector((state) => state.booking?.message);
  const { loading: viewListLoading, deleteLoading } = useSelector(
    (state) => state.booking
  );

  const {
    loading: resendPaymentLoading,
    success: resendPaymentSuccess,
    resendPaymentError,
    data: resendPaymentData,
  } = useSelector((state) => state.booking);

  const { user } = useSelector((state) => state.auth);
  const isStaff = user.role !== "Customer" && user.role !== "Vendor";

  const tab = location?.state?.tab ?? (isStaff ? 0 : 2);
  const pageNumber = location?.state?.page ?? 1;
  const complemetStatus = location?.state?.complementaryStatus ?? 2;
  const instantBookingStatus = location?.state?.instantStatus ?? 2;

  const permissions = useMemo(() => {
    let safePermissions = {};

    try {
      if (user?.permissions) {
        safePermissions =
          typeof user.permissions === "string"
            ? JSON.parse(user.permissions)
            : user.permissions;
      }
    } catch (error) {
      safePermissions = {};
    }

    return safePermissions;
  }, [user]);
  const {
    loading: updatePaymentLoading,
    success: updatePaymentSuccess,
    error: updatePaymentError,
  } = useSelector((state) => state.booking.updatePaymentStatus || {});
  const {
    loading: updateBookingLoading,
    success: updateBookingSuccess,
    error: updateBookingError,
  } = useSelector((state) => state.booking.updateBookingStatus || {});
  const [type, setType] = useState(tab);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchColumn, setSearchColumn] = useState("");
  const [open, setOpen] = useState(false);
  const [bookingToDelete, setBookingToDelete] = useState(null);
  const [page, setPage] = useState(pageNumber);
  const [complementaryStatus, setComplementaryStatus] =
    useState(complemetStatus);

  const [instantStatus, setInstantStatus] = useState(instantBookingStatus);
  const currentDate = new Date().toISOString().split("T")[0];
  const [cancelReason, setCancelReason] = useState("");
  const [booked_type, setBooked_type] = useState(1);
  const [allBookings, setAllBookings] = useState([]);

  // Add date filter states
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const searchTimerRef = useRef(null);
  const booking = useSelector((state) => state?.booking);

  const paymentUrl = booking?.data?.payment_url;

  const rowsPerPage = 10;
  let bookingType = "upcoming";
  if (type === 1) {
    bookingType = "previous";
  } else if (type === 3) {
    bookingType = "cancelled";
  } else if (type === 2) {
    bookingType = "upcoming";
  }

  useEffect(() => {
    return () => {
      dispatch(resetBookingDetails());
    };
  }, []);

  useEffect(() => {
    if (resendPaymentSuccess) {
      toast.success(resendPaymentData?.message, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resendRazorpayLinkReset());

          fetchData();
        },
      });

      if (user.customer_id && resendPaymentData?.payment_url) {
        window.location.href = resendPaymentData.payment_url;
      }
    }
    if (resendPaymentError) {
      toast.error(`Failed to send payment link`, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resendRazorpayLinkReset());
          fetchData();
        },
      });
    }
  }, [resendPaymentSuccess, resendPaymentError]);

  useEffect(() => {
    if (updatePaymentSuccess) {
      toast.success("Payment status updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updatePaymentStatusReset());

          fetchData(page, type, searchQuery, searchColumn);
          handleClosePaymentDialog();
        },
      });
    }

    if (updatePaymentError) {
      toast.error(`Failed to update payment status: ${updatePaymentError}`, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updatePaymentStatusReset());
        },
      });
    }
  }, [updatePaymentSuccess, updatePaymentError]);
  useEffect(() => {
    if (updateBookingSuccess) {
      toast.success("Booking status updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updateBookingStatusReset());

          fetchData(page, type, searchQuery, searchColumn);
          handleCloseBookingStatusDialog();
        },
      });
    }

    if (updateBookingError) {
      toast.error(`Failed to update Booking status: ${updateBookingError}`, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updateBookingStatusReset());
        },
      });
    }
  }, [updateBookingSuccess, updateBookingError]);

  const searchTimeoutRef = useRef(null);

  const handleSearch = (query, column) => {
    setSearchQuery(query);

    if (column !== undefined) {
      setSearchColumn(column);
    }

    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }

    if (query) {
      searchTimerRef.current = setTimeout(() => {
        setPage(1);

        fetchData(1, type, query, column || searchColumn);
      }, 1000);
    } else if (query === "" && searchQuery !== "") {
      searchTimerRef.current = setTimeout(() => {
        setPage(1);

        fetchData(1, type, query, column || searchColumn);
      }, 1000);
    }
  };

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);

  const handleColumnChange = (column) => {
    setSearchColumn(column);
  };

  const fetchData = (
    currentPage = page,
    tabType = type,
    search = searchQuery,
    searchBy = searchColumn,
    includeDates = false
  ) => {
    dispatch(resetBookingDetails());

    // Calculate booked_type based on tabType
    let bookedType = 1; // default
    if (tabType === 1 || tabType === 2 || tabType === 3) {
      bookedType = 1;
    } else if (tabType === 4) {
      bookedType = 2;
    } else if (tabType === 5) {
      bookedType = 3;
    }

    // Prepare date range parameters
    const dateParams = {};
    if (includeDates) {
      if (fromDate) dateParams.from_date = fromDate;
      if (toDate) dateParams.to_date = toDate;
    }

    if (user.role === "Customer" || user.role === "Vendor") {
      dispatch(
        fetchCustomerBookingsRequest({
          customer_id: user.customer_id || "",
          vendor_id: user.vendor_id || "",
          pageNo: currentPage,
          pageSize: rowsPerPage,
          type:
            tabType === 2
              ? "upcoming"
              : tabType === 1
              ? "previous"
              : tabType === 3
              ? "cancelled"
              : "upcoming",
          booked_type: "all",
          currentDate,
          search: search || "",
          search_by: searchBy || "",
          ...dateParams, // Add date range to payload
        })
      );
    } else {
      if (tabType === 0) {
        dispatch(
          fetchAllBookingRequest({
            pageNo: currentPage,
            pagesize: rowsPerPage,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams, // Add date range to payload
          })
        );
      } else if (tabType === 4) {
        dispatch(
          fetchComplementaryBookingsRequest({
            pageNo: currentPage,
            pagesize: rowsPerPage,
            approove_status: complementaryStatus,
            currentDate,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams, // Add date range to payload
          })
        );
      } else if (tabType === 5) {
        let instantBookingType;
        switch (instantStatus) {
          case 1:
            instantBookingType = "previous";
            break;
          case 2:
            instantBookingType = "upcoming";
            break;
          case 3:
            instantBookingType = "cancelled";
            break;
          default:
            instantBookingType = "upcoming";
        }

        dispatch(
          fetchInstantBookingsRequest({
            pageNo: currentPage,
            pagesize: rowsPerPage,
            type: instantBookingType,
            currentDate,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams, // Add date range to payload
          })
        );
      } else {
        dispatch(
          fetchBookingsRequest({
            pageNo: currentPage,
            pagesize: rowsPerPage,
            type:
              tabType === 2
                ? "upcoming"
                : tabType === 1
                ? "previous"
                : tabType === 3
                ? "cancelled"
                : "upcoming",
            booked_type: bookedType,
            currentDate,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams, // Add date range to payload
          })
        );
      }
    }
  };

  const handleDateFilterSubmit = () => {
    setPage(1);

    fetchData(1, type, searchQuery, searchColumn, true);
  };

  const handleClearDates = (type) => {
    setFromDate("");
    setToDate("");
    setPage(1);

    fetchData(1, type, searchQuery, searchColumn); // Fetch without dates
  };

  const isInitialLoad = useRef(true);
  // Initial load and tab/status change
  useEffect(() => {
    if (isInitialLoad.current) {
      dispatch(resetBookingDetails());
      fetchData(1, type, "", "", "", "");
      isInitialLoad.current = false;
    } else {
      setPage(1);
    }
  }, [type, complementaryStatus, instantStatus]);

  // Handle page changes
  useEffect(() => {
    if (!isInitialLoad.current) {
      fetchData(page, type, searchQuery, searchColumn, fromDate, toDate);
    }
  }, [page, complementaryStatus, instantStatus]);
  useEffect(() => {
    const processedData = preprocessData(bookings);
    setAllBookings(processedData);
  }, [bookings, searchQuery, searchColumn]);

  const handleView = (booking) => {
    const bookingId = booking?.booking_number;

    if (permissions?.bookings?.view || user?.role === "Admin") {
      navigate(`${VIEW_BOOKINGS.replace(":bookingId", bookingId)}`, {
        state: {
          tab: type,
          page: page,
          complementaryStatus: complementaryStatus,
          instantStatus: instantStatus,
        },
      });
    } else if (user?.role === "Vendor") {
      navigate(`${VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`, {
        state: {
          tab: type,
          page: page,
          complementaryStatus: complementaryStatus,
          instantStatus: instantStatus,
        },
      });
    } else if (user?.role === "Customer") {
      navigate(`${CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`, {
        state: {
          tab: type,
          page: page,
          complementaryStatus: complementaryStatus,
          instantStatus: instantStatus,
        },
      });
    }
  };

  const handleEdit = (booking) => {
    const bookingId = booking?.booking_number;
    if (permissions?.bookings?.edit && user?.role === "Staff") {
      navigate(`${EDIT_BOOKINGS.replace(":bookingId", bookingId)}`, {
        state: {
          tabEdit: type,
          pageEdit: page,
          complementaryStatus: complementaryStatus,
          instantStatus: instantStatus,
        },
      });
    }
    if (user?.role === "Admin") {
      navigate(`${EDIT_BOOKINGS.replace(":bookingId", bookingId)}`, {
        state: {
          bookingData: booking,
          tabEdit: type,
          pageEdit: page,
          complementaryStatus: complementaryStatus,
          instantStatus: instantStatus,
        },
      });
    }
    if (user?.role === "Vendor") {
      navigate(`${VENDOR_EDIT_BOOKINGS.replace(":bookingId", bookingId)}`, {
        state: {
          bookingData: booking,
          tabEdit: type,
          pageEdit: page,
          complementaryStatus: complementaryStatus,
          instantStatus: instantStatus,
        },
      });
    }
  };

  const isFutureDate = (dateStr) => {
    if (!dateStr || dateStr.trim().toLowerCase().includes("null")) return false;
    const date = new Date(dateStr.trim());
    return !isNaN(date.getTime()) && date.getTime() > new Date().getTime();
  };

  const shouldShowResendPaymentButton = (item) => {
    const {
      payment_status,
      booked_type,
      datetime_of_arrival,
      datetime_of_departure,
    } = item;
    const isFutureArrivalOrDeparture =
      isFutureDate(datetime_of_arrival) || isFutureDate(datetime_of_departure);

    return (
      payment_status !== 1 && booked_type !== 2 && isFutureArrivalOrDeparture
    );
  };

  const handleResendPayment = (booking) => {
    const payload = {
      customer_id: booking.customer_id || user.customer_id,
      razorpay_order_id: booking.razorpay_order_id,
    };

    dispatch(resendRazorpayLinkRequest(payload));
  };

  const renderResendPaymentButton = (item) => {
    if (!shouldShowResendPaymentButton(item)) return null;

    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleResendPayment(item)}
        className="orange-button"
        disabled={resendPaymentLoading}
      >
        {resendPaymentLoading ? "SENDING..." : "RETRY"}
      </Button>
    );
  };

  const handleOpenPopup = (booking) => {
    setBookingToDelete(booking);
    setOpen(true);
  };

  const handleClosePopup = () => {
    setBookingToDelete(null);
    setOpen(false);
  };

  useEffect(() => {
    if (deleteSuccess === "Your bookingservice cancelled") {
      toast.success("Your bookingservice cancelled", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
          fetchData(page, type, searchQuery, searchColumn, fromDate, toDate);
        },
      });
    }
  }, [deleteSuccess]);

  const filteredBookings = useMemo(() => {
    if (!searchQuery) return allBookings;

    return allBookings.filter((booking) => {
      const bookingNumberMatch = booking.booking_serial_no
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const bookingDateMatch = booking.date_of_booking
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const bookedByMatch = booking.booked_user_name
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase());
      const bookedForMatch = booking.booked_for
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase());
      const serviceMatch = booking.service
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase());
      const serviceTypeMatch = booking.service_type_label
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase());
      const pnrMatch = booking.pnr_number
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const arrivalFlightMatch = booking.arrival_flight_number
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const departureFlightMatch = booking.departure_flight_number
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      // Return true if any field matches
      return (
        bookingNumberMatch ||
        bookingDateMatch ||
        bookedByMatch ||
        bookedForMatch ||
        serviceMatch ||
        serviceTypeMatch ||
        pnrMatch ||
        arrivalFlightMatch ||
        departureFlightMatch
      );
    });
  }, [allBookings, searchQuery]);

  const handleConfirmDelete = () => {
    if (bookingToDelete) {
      const bookingId = bookingToDelete.booking_number;
      dispatch(deleteBookingRequest({ bookingId, cancel_notes: cancelReason }));
    }
    handleClosePopup();
  };

  // FIXED: Simplified handleTabChange
  const handleTabChange = (event, newType) => {
    setType(newType);
    setPage(1); // Reset page to 1
    handleClearDates(newType);

    // Reset complementary and instant status when switching tabs
    if (newType !== 4) {
      setComplementaryStatus(2);
    }
    if (newType !== 5) {
      setInstantStatus(2);
    }

    // Don't call fetchData here - the useEffect will handle it
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleIndividualExport = (booking) => {
    try {
      // Multiple ways to determine service type
      const serviceTypeLabel = (booking.service_type_label || "").toLowerCase();
      const serviceMode = (booking.service_mode || "").toLowerCase();
      const service = (booking.service || "").toLowerCase();

      // Check if this is a transit booking
      const isTransit =
        serviceTypeLabel.includes("transit") ||
        serviceMode.includes("transit") ||
        service.includes("transit");

      // Check various fields to determine service type
      const isDepartureByLabel =
        serviceTypeLabel.includes("departure") ||
        serviceMode.includes("departure") ||
        service.includes("departure");

      const isDepartureByData =
        booking.datetime_of_departure &&
        booking.datetime_of_departure !== "-" &&
        booking.datetime_of_departure !== null;

      const isArrivalByLabel =
        serviceTypeLabel.includes("arrival") ||
        serviceMode.includes("arrival") ||
        service.includes("arrival");

      const isArrivalByData =
        booking.datetime_of_arrival &&
        booking.datetime_of_arrival !== "-" &&
        booking.datetime_of_arrival !== null;

      // Determine final service type
      let isDeparture = false;
      let isArrival = false;

      if (isTransit) {
        // For transit, we need to show both arrival and departure info
        isArrival = true;
        isDeparture = true;
      } else if (isDepartureByLabel) {
        isDeparture = true;
      } else if (isArrivalByLabel) {
        isArrival = true;
      } else if (isDepartureByData && !isArrivalByData) {
        isDeparture = true;
      } else if (isArrivalByData && !isDepartureByData) {
        isArrival = true;
      } else if (isArrivalByData) {
        isArrival = true; // Default to arrival if both exist
      }

      const getAirportCity = () => {
        if (isTransit) {
          // For transit, show both arrival and departure cities
          const arrivalCity = booking.arrival_city || "";
          const departureCity = booking.departure_city || "";

          if (arrivalCity && departureCity) {
            return `Arrival: ${arrivalCity} | Departure: ${departureCity}`;
          } else if (arrivalCity) {
            return `Arrival: ${arrivalCity}`;
          } else if (departureCity) {
            return `Departure: ${departureCity}`;
          }
          // Fallback to airport_name if cities are not available
          return booking.airport_name || "-";
        } else if (isDeparture && booking.departure_city) {
          return booking.departure_city;
        } else if (isArrival && booking.arrival_city) {
          return booking.arrival_city;
        }
        // Fallback: try both cities first, then airport_name
        return (
          booking.departure_city ||
          booking.arrival_city ||
          booking.airport_name ||
          "-"
        );
      };

      // Helper function to get service date
      const getServiceDate = () => {
        const cleanDate = (dateTime) => {
          if (!dateTime || dateTime === "-") return null;
          const dateStr = formatDateWithAmPm(dateTime).split(" ")[0];
          // Remove any trailing comma or unwanted characters
          return dateStr.replace(/[,\s]+$/, "").trim();
        };

        if (isTransit) {
          // For transit, prioritize arrival date, then departure
          const arrivalDate = cleanDate(booking.datetime_of_arrival);
          if (arrivalDate) return arrivalDate;

          const departureDate = cleanDate(booking.datetime_of_departure);
          if (departureDate) return departureDate;
        } else if (isDeparture) {
          const departureDate = cleanDate(booking.datetime_of_departure);
          if (departureDate) return departureDate;
        } else if (isArrival) {
          const arrivalDate = cleanDate(booking.datetime_of_arrival);
          if (arrivalDate) return arrivalDate;
        }

        // Fallback: try both
        const departureDate = cleanDate(booking.datetime_of_departure);
        if (departureDate) return departureDate;

        const arrivalDate = cleanDate(booking.datetime_of_arrival);
        if (arrivalDate) return arrivalDate;

        return "-";
      };

      // Helper function to get flight time
      const getFlightTime = () => {
        if (isTransit) {
          // For transit, show both arrival and departure times
          let arrivalTime = "";
          let departureTime = "";

          if (
            booking.datetime_of_arrival &&
            booking.datetime_of_arrival !== "-"
          ) {
            arrivalTime = formatDateWithAmPm(booking.datetime_of_arrival)
              .split(" ")
              .slice(1)
              .join(" ");
          }

          if (
            booking.datetime_of_departure &&
            booking.datetime_of_departure !== "-"
          ) {
            departureTime = formatDateWithAmPm(booking.datetime_of_departure)
              .split(" ")
              .slice(1)
              .join(" ");
          }

          if (arrivalTime && departureTime) {
            return `Arrival: ${arrivalTime} | Departure: ${departureTime}`;
          } else if (arrivalTime) {
            return `Arrival: ${arrivalTime}`;
          } else if (departureTime) {
            return `Departure: ${departureTime}`;
          }
          return "-";
        } else if (isDeparture) {
          if (
            booking.datetime_of_departure &&
            booking.datetime_of_departure !== "-"
          ) {
            return formatDateWithAmPm(booking.datetime_of_departure)
              .split(" ")
              .slice(1)
              .join(" ");
          }
        } else if (isArrival) {
          if (
            booking.datetime_of_arrival &&
            booking.datetime_of_arrival !== "-"
          ) {
            return formatDateWithAmPm(booking.datetime_of_arrival)
              .split(" ")
              .slice(1)
              .join(" ");
          }
        }
        // Fallback: try both
        if (
          booking.datetime_of_departure &&
          booking.datetime_of_departure !== "-"
        ) {
          return formatDateWithAmPm(booking.datetime_of_departure)
            .split(" ")
            .slice(1)
            .join(" ");
        }
        if (
          booking.datetime_of_arrival &&
          booking.datetime_of_arrival !== "-"
        ) {
          return formatDateWithAmPm(booking.datetime_of_arrival)
            .split(" ")
            .slice(1)
            .join(" ");
        }
        return "-";
      };

      // Helper function to get airline
      const getAirline = () => {
        if (isTransit) {
          // For transit, show both airlines
          const arrivalAirline = booking.arrival_airline || "";
          const departureAirline = booking.departure_airline || "";

          if (arrivalAirline && departureAirline) {
            return `Arrival: ${arrivalAirline} | Departure: ${departureAirline}`;
          } else if (arrivalAirline) {
            return `Arrival: ${arrivalAirline}`;
          } else if (departureAirline) {
            return `Departure: ${departureAirline}`;
          }
          return "-";
        } else if (isDeparture && booking.departure_airline) {
          return booking.departure_airline;
        } else if (isArrival && booking.arrival_airline) {
          return booking.arrival_airline;
        }
        // Fallback: try both
        return booking.departure_airline || booking.arrival_airline || "-";
      };

      // Helper function to get flight number
      const getFlightNumber = () => {
        if (isTransit) {
          // For transit, show both flight numbers
          const arrivalFlightNumber = booking.arrival_flight_number || "";
          const departureFlightNumber = booking.departure_flight_number || "";

          if (arrivalFlightNumber && departureFlightNumber) {
            return `Arrival: ${arrivalFlightNumber} | Departure: ${departureFlightNumber}`;
          } else if (arrivalFlightNumber) {
            return `Arrival: ${arrivalFlightNumber}`;
          } else if (departureFlightNumber) {
            return `Departure: ${departureFlightNumber}`;
          }
          return "-";
        } else if (isDeparture && booking.departure_flight_number) {
          return booking.departure_flight_number;
        } else if (isArrival && booking.arrival_flight_number) {
          return booking.arrival_flight_number;
        }
        // Fallback: try both
        return (
          booking.departure_flight_number ||
          booking.arrival_flight_number ||
          "-"
        );
      };

      // Helper function to get PNR
      const getPNR = () => {
        if (isTransit) {
          // For transit, show both PNRs
          const arrivalPNR = booking.arival_pnr_by_customer || "";
          const departurePNR = booking.departure_pnr_by_customer || "";
          const generalPNR = booking.pnr_number || "";

          if (arrivalPNR && departurePNR) {
            return `Arrival: ${arrivalPNR} | Departure: ${departurePNR}`;
          } else if (arrivalPNR) {
            return `Arrival: ${arrivalPNR}`;
          } else if (departurePNR) {
            return `Departure: ${departurePNR}`;
          } else if (generalPNR) {
            return generalPNR;
          }
          return "-";
        } else if (isDeparture && booking.departure_pnr_by_customer) {
          return booking.departure_pnr_by_customer;
        } else if (isArrival && booking.arival_pnr_by_customer) {
          return booking.arival_pnr_by_customer;
        }
        // Fallback: try all possibilities
        return (
          booking.departure_pnr_by_customer ||
          booking.arival_pnr_by_customer ||
          booking.pnr_number ||
          "-"
        );
      };

      // Create CSV content with proper formatting for Excel alignment
      const csvRows = [
        ["Guest Name", `\t${booking.booked_for || "-"}`],
        ["Placard Guest Name", `\t${booking.booked_for || "-"}`],
        [
          "Guest Contact No.",
          (booking?.contact || "-") +
            " / " +
            (booking?.emergency_contact || "-"),
        ],
        ["No. of Pax", `\t${booking.total_passenger || "1"}`],
        ["Service Date", `\t${getServiceDate()}`],
        ["Airport", `\t${getAirportCity() || "-"}`],
        ["Terminal", `\t${booking.service_types || "-"}`],
        ["Service Type", `\t${booking.service || "-"}`],
        ["Service Mode", `\t${booking.service_type_label || "-"}`],
        ["Airline", `\t${getAirline()}`],
        ["Flight Number", `\t${getFlightNumber()}`],
        ["Flight Time", `\t${getFlightTime()}`],
        ["PNR No.", `\t${getPNR()}`],
        ["Remarks", `\t${booking.notes || "-"}`],
      ];

      // Convert to CSV format with proper escaping
      const csvContent = csvRows
        .map((row) =>
          row
            .map((field) => {
              // Convert field to string and handle special characters
              let stringField = String(field || "");

              // For Excel alignment, we can use specific formatting
              if (
                stringField.includes(",") ||
                stringField.includes('"') ||
                stringField.includes("\n") ||
                stringField.includes("\t")
              ) {
                // Escape quotes and wrap in quotes
                return `"${stringField.replace(/"/g, '""')}"`;
              }
              return stringField;
            })
            .join(",")
        )
        .join("\n");

      // Add UTF-8 BOM to fix encoding issues
      const BOM = "\uFEFF";
      const csvWithBOM = BOM + csvContent;

      // Create and download the file
      const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
      const fileName = `booking_${booking.booking_serial_no}.csv`;
      saveAs(blob, fileName);

      // toast.success("Booking details exported successfully!", {
      //   position: "top-center",
      //   autoClose: 2000,
      // });
    } catch (error) {
      toast.error("Failed to export booking details", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };
  // NEW: Render individual export button (only for Admin and Staff)
  const renderIndividualExportButton = (item) => {
    if (user?.role !== "Admin" && user?.role !== "Staff") {
      return null;
    }

    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleIndividualExport(item)}
        className="orange-button"
      >
        EXPORT
      </Button>
    );
  };
  const handleExport = () => {
    let apiParams = {
      pagination_required: false,
    };
    if (fromDate) apiParams.from_date = fromDate;
    if (toDate) apiParams.to_date = toDate;
    if (type === 0) {
      apiParams = {
        ...apiParams,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    } else if (type === 4) {
      apiParams = {
        ...apiParams,
        approove_status: complementaryStatus,
        booked_type: 2,
        currentDate,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    } else if (type === 5) {
      let instantBookingType;
      switch (instantStatus) {
        case 1:
          instantBookingType = "previous";
          break;
        case 2:
          instantBookingType = "upcoming";
          break;
        case 3:
          instantBookingType = "cancelled";
          break;
        default:
          instantBookingType = "upcoming";
      }

      apiParams = {
        ...apiParams,
        type: instantBookingType,
        booked_type: 3,
        currentDate,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    } else {
      apiParams = {
        ...apiParams,
        type: type === 2 ? "upcoming" : type === 1 ? "previous" : "cancelled",
        booked_type: booked_type,
        currentDate,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    }

    let apiCall;

    if (user.role === "Customer" || user.role === "Vendor") {
      apiCall = axiosInstance.get("/bookservice/bookinggetbycustomer", {
        params: {
          ...apiParams,
          customer_id: user.customer_id || "",
          vendor_id: user.vendor_id || "",
          booked_type: "all",
        },
      });
    } else {
      let endpoint;
      if (type === 0) {
        endpoint = "bookservice/servicebookingalldata";
      } else if (type === 4) {
        endpoint = "bookservice/complementrybookingservice";
      } else if (type === 5) {
        endpoint = "bookservice/list";
      } else {
        endpoint = "/bookservice/list";
      }

      apiCall = axiosInstance.get(endpoint, { params: apiParams });
    }

    apiCall
      .then((response) => {
        let bookingsData = response?.data?.data || [];

        const processedData = preprocessData(bookingsData);

        const csvHeaders = [
          "Booking Number",
          "Booking Date",
          "Booked User Name",
          "Booked For",
          "Airport Name",
          "Airport Type",
          "First Name",
          "Last Name",
          "Company Name",
          "No Of Adult",
          "No Of Child",
          "No Of Infant",
          "Total Passenger",
          "Service",
          "Service Type",
          "Notes",
          "Arrival Date/Time",
          "Arrival City",
          "Arrival Airline",
          "Arrival Flight Number",
          "Arrival PNR By Customer",
          "Departure Date/Time",
          "Departure City",
          "Departure Airline",
          "Departure Flight Number",
          "Departure PNR By Customer",
          "Payment Reference Number",
          "Payment Status",
          "Approval Status",
          "Booked Type",
        ];
        const csvRows = processedData.map((booking) => {
          const escapeCsvField = (field) => {
            if (field === null || field === undefined) return '""';
            const stringField = String(field || "-");
            if (
              stringField.includes(",") ||
              stringField.includes('"') ||
              stringField.includes("\n")
            ) {
              return `"${stringField.replace(/"/g, '""')}"`;
            }
            return stringField;
          };

          const getApprovalStatusText = (statusCode) => {
            if (statusCode === 1 || statusCode === "1") return "Approved";
            if (statusCode === 2 || statusCode === "2") return "Pending";
            if (statusCode === 3 || statusCode === "3") return "Rejected";
            return statusCode || "";
          };

          const getPaymentStatusText = (statusCode, bookedType) => {
            if (statusCode === 1) return "Completed";
            if (statusCode === 0 && bookedType === 2)
              return "Free (Complementary)";
            if (statusCode === 0) return "Pending";
            if (statusCode === 2) return "Failed";
            if (statusCode === 3) return "Refunded";
            return "Aborted";
          };

          const getBookedTypeLabel = (typeCode) => {
            switch (typeCode) {
              case 1:
                return "Regular";
              case 2:
                return "Complementary";
              case 3:
                return "Instant Booking";
              default:
                return typeCode || "";
            }
          };

          const approvalStatus = booking.approove_status;
          const approvalStatusText = getApprovalStatusText(approvalStatus);
          const paymentStatusText = getPaymentStatusText(
            booking.payment_status,
            booking.booked_type
          );

          return [
            escapeCsvField(booking.booking_serial_no),
            escapeCsvField(formatDateWithAmPm(booking.date_of_booking)),
            escapeCsvField(booking.booked_user_name),
            escapeCsvField(booking.booked_for),
            escapeCsvField(booking.airport_name),
            escapeCsvField(booking.airport_type),
            escapeCsvField(booking.first_name),
            escapeCsvField(booking.last_name),
            escapeCsvField(booking.company_name),
            escapeCsvField(booking.number_of_adults),
            escapeCsvField(booking.number_of_child),
            escapeCsvField(booking.number_of_infant),
            escapeCsvField(booking.total_passenger),
            escapeCsvField(booking.service),
            escapeCsvField(booking.service_type_label),
            escapeCsvField(booking.notes),
            escapeCsvField(formatDateWithAmPm(booking.datetime_of_arrival)),
            escapeCsvField(booking.arrival_city),
            escapeCsvField(booking.arrival_airline),
            escapeCsvField(booking.arrival_flight_number),
            escapeCsvField(booking.arival_pnr_by_customer),
            escapeCsvField(formatDateWithAmPm(booking.datetime_of_departure)),
            escapeCsvField(booking.departure_city),
            escapeCsvField(booking.departure_airline),
            escapeCsvField(booking.departure_flight_number),
            escapeCsvField(booking.departure_pnr_by_customer),
            escapeCsvField(booking.pnr_number),
            escapeCsvField(paymentStatusText),
            escapeCsvField(approvalStatusText),
            escapeCsvField(getBookedTypeLabel(booking.booked_type)),
          ].join(",");
        });
        const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, `bookings_${new Date().toISOString().split("T")[0]}.csv`);
      })
      .catch((error) => {});
  };
  const preprocessData = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    const data1 = data.map((item) => {
      const item1 = item?.BookingDetail;
      return { item1 };
    });

    return data.map((item) => {
      const bookingUpdateLogs = item?.bookingUpdateLogs || [];
      if (
        !Array.isArray(bookingUpdateLogs) &&
        typeof bookingUpdateLogs === "object"
      ) {
        bookingUpdateLogs = [bookingUpdateLogs];
      }

      // Get the first log if exists
      const latestLog =
        bookingUpdateLogs.length > 0 ? bookingUpdateLogs[0] : null;
      const bookingDetail = item.BookingDetail || {};
      const billingAddress = item.BillingAddress || {};
      const customerContact = item?.Customer?.phone || {};
      const service = item.Service.type_of_service || {};
      const order = item.Order || {};
      const numberOfAdults = bookingDetail.number_of_adults || 0;
      const numberOfChildren = bookingDetail.number_of_child || 0;
      const numberOfInfants = bookingDetail.number_of_infant || 0;
      const totalPassengers =
        numberOfAdults + numberOfChildren + numberOfInfants;
      const bookedUser = bookingDetail["BookedUser"] || {};
      let bookedUserName = "-";

      const user_type = bookedUser?.user_type || 0;

      if (user_type === 3 && bookedUser?.Customer) {
        bookedUserName = bookedUser?.Customer?.full_name;
      } else if (user_type === 2 && bookedUser?.Vendor) {
        bookedUserName = bookedUser?.Vendor?.full_name;
      } else if (user_type === 4 && bookedUser?.Staff) {
        bookedUserName = bookedUser?.Staff?.full_name;
      } else {
        bookedUserName = `${bookedUser?.first_name || ""} ${
          bookedUser?.last_name || ""
        }`.trim();
      }

      return {
        is_mobile: item?.is_mobile,
        booking_number: item.id || "-",
        booking_serial_no: item.booking_serial_no || "",
        date_of_booking: item.created_at ? item.created_at : "-",
        booked_user_name: bookedUserName,
        promo_code: item?.Promocode?.discount_code || "-",
        booked_for: item?.bookingFamilies?.[0]?.familyMember?.first_name,
        pnr_number: item?.pnr_number,
        airport_name: item?.Airport?.name || "-",
        airport_type: item?.Airport?.airport_type || "-",
        first_name: billingAddress.first_name || "-",
        last_name: billingAddress.last_name || "-",
        company_name: billingAddress.company_name || "-",
        number_of_adults: numberOfAdults || "-",
        number_of_child: numberOfChildren || "-",
        number_of_infant: numberOfInfants || "-",
        total_passenger: totalPassengers,
        service: item.Service?.services || order.service || "-",
        service_type_label:
          { 1: "Arrival", 2: "Departure", 3: "Transit" }[item.service_type] ||
          "-",
        notes: bookingDetail.notes || "-",
        datetime_of_arrival:
          bookingDetail?.date_of_arrival !== "2000-01-01"
            ? bookingDetail?.time_of_arrival
              ? `${bookingDetail?.date_of_arrival} ${bookingDetail?.time_of_arrival}`
              : `${bookingDetail?.date_of_arrival}`
            : "-",

        datetime_of_departure:
          bookingDetail?.date_of_departure !== "2000-01-01"
            ? bookingDetail?.time_of_departure
              ? `${bookingDetail?.date_of_departure} ${bookingDetail?.time_of_departure}`
              : `${bookingDetail?.date_of_departure}`
            : "-",

        arrival_city:
          item?.Service.type_of_name === "arrival"
            ? item.Airport?.name
            : bookingDetail.arrival_from_city || "-",

        arrival_airline: bookingDetail.arrival_airlines || "-",
        arrival_flight_number: bookingDetail.arrival_flight_number || "-",
        arival_pnr_by_customer: item?.arival_pnr_by_customer || "-",
        departure_city:
          item?.Service.type_of_name === "departure"
            ? item.Airport?.name
            : bookingDetail.departure_from_city || "-",

        departure_airline: bookingDetail.departure_airlines || "-",
        departure_flight_number: bookingDetail.departure_flight_number || "-",
        departure_pnr_by_customer: item?.departure_pnr_by_customer || "-",
        payment_status: item?.payment_status || 0,
        approove_status: item.approove_status,
        booked_type: item.booked_type,
        user_type: user_type,
        contact: customerContact,
        emergency_contact: billingAddress?.emergency_contact,
        service_types: service,
        staff_update_status: latestLog ? latestLog.staff_update_status : null,
        booking_status_update_by: latestLog?.Staff?.full_name || "-",
        // Add additional fields for resend payment functionality
        customer_id: item?.customer_id,
        razorpay_order_id: item?.razorpay_order_id || item?.pnr_number,
      };
    });
  };
  if (viewListLoading) {
    return <Loading text="Loading Booking Details..." />;
  }

  const paginatedData = filteredBookings;

  const headers = (tab, page, complementaryStatus, instantStatus) => [
    {
      field: "booking_serial_no",
      header: "Booking Number",

      isClickable: true,
      render: (value, row) => {
        console.log("isRow", row?.is_mobile);
        const sourceBadge =
          row.is_mobile == 0
            ? { label: "Mobile", color: "rgb(251,207,154)" }
            : { label: "Web", color: "rgb(52,207,229)" };

        console.log("sourceBadge", sourceBadge);

        return (
          <Box
            sx={{
              backgroundColor: sourceBadge?.color,
              borderRadius: 3,
              display: "inline-block", // keeps the box tight around text
            }}
          >
            <Typography
              sx={{
                color: "white",
                padding: 1,
                textDecoration: "none",
                borderRadius: 3,
              }}
            >
              {value}
            </Typography>
          </Box>
        );
      },
      // onClick: (row) => {
      //   const bookingId = row.booking_number;
      //   if (permissions?.bookings?.view || user?.role === "Admin") {

      //     return `${VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
      //   } else if (user?.role === "Vendor") {
      //     return `${VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
      //   } else if (user?.role === "Customer") {
      //     return `${CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
      //   }
      // },
      onClick: (row) => {
        const bookingId = row.booking_number;
        const state = { tab, page, complementaryStatus, instantStatus }; // 👈 extra state you want to pass

        if (permissions?.bookings?.view || user?.role === "Admin") {
          return {
            pathname: VIEW_BOOKINGS.replace(":bookingId", bookingId),
            state,
          };
        } else if (user?.role === "Vendor") {
          return {
            pathname: VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId),
            state,
          };
        } else if (user?.role === "Customer") {
          return {
            pathname: CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId),
            state,
          };
        }
      },
    },

    {
      field: "date_of_booking",
      header: "Booking Date",
      render: (value) => (value ? formatDateWithAmPm(value) : "-"),
    },
    {
      field: "booked_user_name",
      header: "Booked By",

      render: (value, row) => {
        // if (row.user_type === 1) {
        //   return <span className="badge admin-badge">{value} (Admin)</span>;
        // } else
        if (row.user_type === 2) {
          return <span className="badge vendor-badge">{value} (Vendor)</span>;
        } else if (row.user_type === 3) {
          return (
            <span className="badge customer-badge">{value} (Customer)</span>
          );
        }
        return value;
      },
      isClickable: true,
      // onClick: (row) => {
      //   const bookingId = row.booking_number;
      //   if (permissions?.bookings?.view || user?.role === "Admin") {
      //     return `${VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
      //   } else if (user?.role === "Vendor") {
      //     return `${VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
      //   } else if (user?.role === "Customer") {
      //     return `${CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
      //   }
      // },
      onClick: (row) => {
        const bookingId = row.booking_number;
        const state = { tab, page, complementaryStatus, instantStatus }; // 👈 extra state you want to pass

        if (permissions?.bookings?.view || user?.role === "Admin") {
          return {
            pathname: VIEW_BOOKINGS.replace(":bookingId", bookingId),
            state,
          };
        } else if (user?.role === "Vendor") {
          return {
            pathname: VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId),
            state,
          };
        } else if (user?.role === "Customer") {
          return {
            pathname: CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId),
            state,
          };
        }
      },
    },
    { field: "booked_for", header: "Booked For" },
    { field: "number_of_adults", header: "No of Adults" },
    { field: "number_of_child", header: "No of Children" },
    { field: "number_of_infant", header: "No of Infants" },
    { field: "total_passenger", header: "Total Passengers" },
    { field: "service", header: "Service" },
    { field: "service_type_label", header: "Service Type" },
    {
      field: "datetime_of_arrival",
      header: "Arrival Date/Time",
      render: (value) => (value ? formatDateWithAmPmBooking(value) : "-"),
    },
    { field: "arrival_city", header: "Arrival City" },
    { field: "arrival_airline", header: "Arrival Airline" },
    {
      field: "arrival_flight_number",
      header: "Arrival Flight Number",
    },
    {
      field: "arival_pnr_by_customer",
      header: "Arrival PNR Number",
    },
    {
      field: "datetime_of_departure",
      header: "Departure Date/Time",
      render: (value) => {
        return value ? formatDateWithAmPmBooking(value) : "-";
      },
    },

    { field: "departure_city", header: "Departure City" },
    { field: "departure_airline", header: "Departure Airline" },
    {
      field: "departure_flight_number",
      header: "Departure Flight Number",
    },
    {
      field: "departure_pnr_by_customer",
      header: "Departure PNR Number",
    },
    { field: "pnr_number", header: "Payment Reference Number" },

    {
      field: "payment_status",
      header: "Payment Status",
      render: (value, row) => {
        return (
          <Chip
            label={
              value === 1
                ? "Completed"
                : value === 0 && row?.booked_type === 2
                ? `Free
                      (Complementary)
                    `
                : value === 0
                ? `pending
                    `
                : value === 2
                ? "Failed"
                : value === 3
                ? "Refunded"
                : "Aborted"
            }
            color={
              value === 1
                ? "success"
                : value === 0 && row?.booked_type === 2
                ? "success"
                : value === 2
                ? "error"
                : value === 3
                ? "success"
                : value === 0
                ? "warning"
                : "error"
            }
            size="small"
          />
        );
      },
    },

    ...(user?.user_type !== 2 && user?.user_type !== 3
      ? [
          {
            field: "staff_update_status",
            header: "Booking Status",
            render: (value) => {
              if (value === undefined || value === null) return "-";

              const statusMap = {
                1: { label: "Pending", color: "warning" },
                2: { label: "Processing", color: "warning" },
                3: { label: "Completed", color: "success" },
                4: { label: "Cancelled", color: "error" },
              };

              return (
                <Chip
                  label={statusMap[value]?.label || "-"}
                  color={statusMap[value]?.color || "default"}
                  size="small"
                />
              );
            },
          },
          { field: "booking_status_update_by", header: "Updated By" },
        ]
      : []),

    { field: "promo_code", header: "Promo Code" },
    { field: "notes", header: "Notes" },
  ];

  const bookingFilterHeaders = [
    { value: "booking_serial_no", label: "Booking Number" },
    { value: "date_of_booking", label: "Booking Date" },
    { value: "booked_user_name", label: "Booked By" },
    { value: "booked_for", label: "Booked For" },
    { value: "service", label: "Service" },
    { value: "service_type_label", label: "Service Type" },
  ];

  const renderCustomDeleteButton = (item) => {
    if (type === 3 || type === 1) {
      return null;
    }
    return (
      (user?.user_type !== 1 && user?.user_type !== 2
        ? permissions?.bookings?.edit ||
          user?.user_type === 1 ||
          user?.user_type === 2
        : user?.user_type === 1) && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleOpenPopup(item)}
          className="grey-button"
        >
          CANCEL
        </Button>
      )
    );
  };

  const renderCustomEditButton = (item) => {
    if (type === 3 || type === 1) return null;

    const isFutureDate = (dateString) => {
      if (!dateString || dateString === "-" || dateString === "2000-01-01") {
        return false;
      }
      const datePart = dateString.trim().split(" ")[0];
      const itemDate = new Date(datePart);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      itemDate.setHours(0, 0, 0, 0);

      return itemDate > today;
    };
    const arrivalIsFuture = isFutureDate(item.datetime_of_arrival);
    const departureIsFuture = isFutureDate(item.datetime_of_departure);

    const canEdit = arrivalIsFuture || departureIsFuture;

    const hasPermission =
      user?.user_type !== 1 && user?.user_type !== 2
        ? permissions?.bookings?.edit ||
          user?.user_type === 1 ||
          user?.user_type === 2
        : user?.user_type === 1 || user?.user_type === 2;

    return (
      hasPermission &&
      canEdit && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleEdit(item)}
          className="orange-button"
        >
          EDIT
        </Button>
      )
    );
  };
  const renderCustomViewButton = (item) =>
    (user?.user_type !== 1 && user?.user_type !== 2 && user?.user_type !== 3
      ? permissions?.bookings?.view ||
        user?.user_type === 1 ||
        user?.user_type === 2
      : user?.user_type === 1 ||
        user?.user_type === 2 ||
        user?.user_type === 3) && (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleView(item)}
        className="grey-button"
      >
        VIEW
      </Button>
    );

  const getTotalPages = () => {
    return Math.max(1, Math.ceil(totalRecord / rowsPerPage));
  };
  // Open payment update dialog
  const handleOpenPaymentUpdate = (booking) => {
    setSelectedBooking(booking);

    setPaymentStatus(String(booking.payment_status || "1"));
    setUpdatePaymentDialogOpen(true);
  };

  // Close dialog and reset
  const handleClosePaymentDialog = () => {
    setUpdatePaymentDialogOpen(false);
    setSelectedBooking(null);
    // if (updatePaymentSuccess || updatePaymentError) {
    //   dispatch(updatePaymentStatusReset());
    // }
  };

  // Submit payment status update
  const handleUpdatePaymentStatus = () => {
    if (!selectedBooking) return;

    const payload = {
      booking_id: selectedBooking.booking_number,
      payment_status: paymentStatus,
      payment_refrence_number: referenceNumber,
    };

    dispatch(updatePaymentStatusRequest(payload));
  };
  // Open payment update dialog
  const handleOpenBookingStatusUpdate = (booking) => {
    setSelectedBooking(booking);
    setPaymentStatus(String(booking.payment_status || "1"));
    setUpdateBookingDialogOpen(true);
  };

  // Close dialog and reset
  const handleCloseBookingStatusDialog = () => {
    setUpdateBookingDialogOpen(false);
    setSelectedBooking(null);
    if (updatePaymentSuccess || updatePaymentError) {
      dispatch(updateBookingStatusReset());
    }
  };

  const handleUpdateBookingStatus = () => {
    if (!selectedBooking) return;

    const payload = {
      booking_id: selectedBooking.booking_number,
      staff_update_status: bookingStatus,
    };

    dispatch(updateBookingStatusRequest(payload));
  };
  const renderPaymentUpdateButton = (item) =>
    (["Admin"].includes(user?.role) ||
      ["Manager"].includes(user?.role_name)) && (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleOpenPaymentUpdate(item)}
        className="grey-button"
        sx={{ width: "130px" }}
      >
        UPDATE STATUS
      </Button>
    );
  const renderBookingUpdateButton = (item) =>
    (["Admin"].includes(user?.role) ||
      ["Manager"].includes(user?.role_name)) && (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleOpenBookingStatusUpdate(item)}
        className="orange-button"
        sx={{ width: "150px" }}
      >
        BOOKING STATUS
      </Button>
    );

  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <SearchAndButtonTab
                  title="Bookings"
                  columns={bookingFilterHeaders}
                  searchColumn={searchColumn}
                  hideSearchColumnSelector={true}
                  setSearchColumn={handleColumnChange}
                  searchQuery={searchQuery}
                  setSearchQuery={handleSearch}
                  handleExport={handleExport}
                  routeName={
                    user.role === "Vendor"
                      ? VENDOR_BOOKING_AIRPORT_DETAILS
                      : user.role === "Customer"
                      ? CUSTOMER_BOOKING_AIRPORT_DETAILS
                      : BOOKING_AIRPORT_DETAILS
                  }
                  permissions={permissions}
                  user={user}
                />
                {(user?.role === "Admin" || user?.role === "Staff") && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      mb: 2,
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <TextField
                      label="From Date"
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 180 }}
                      inputProps={{ max: toDate || currentDate }}
                    />
                    <TextField
                      label="To Date"
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 180 }}
                      inputProps={{
                        min: fromDate,
                        max: currentDate,
                      }}
                    />

                    <Button
                      variant="contained"
                      onClick={handleDateFilterSubmit}
                      disabled={!fromDate && !toDate}
                      className="orange-button"
                    >
                      Apply Dates
                    </Button>

                    <Button
                      variant="outlined"
                      onClick={handleClearDates}
                      disabled={!fromDate && !toDate}
                      className="grey-button"
                    >
                      Clear Dates
                    </Button>
                  </Box>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Tabs
                    value={type}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                  >
                    {user.role !== "Customer" && user.role !== "Vendor" && (
                      <Tab label="All" value={0} />
                    )}
                    <Tab label="Upcoming" value={2} />
                    <Tab label="Completed" value={1} />
                    <Tab label="Cancelled" value={3} />
                    {user.role !== "Customer" && user.role !== "Vendor" && (
                      <Tab label="Complementary" value={4} />
                    )}
                    {user.role !== "Customer" && user.role !== "Vendor" && (
                      <Tab label="Instant Booking" value={5} />
                    )}
                  </Tabs>
                </Box>

                {type === 4 && (
                  <Tabs
                    value={complementaryStatus}
                    onChange={(event, newStatus) =>
                      setComplementaryStatus(newStatus)
                    }
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{
                      ml: 2,
                      "& .MuiTabs-indicator": {
                        backgroundColor: "primary.main",
                      },
                    }}
                  >
                    <Tab label="Pending" value={2} className="tab-heights" />
                    <Tab label="Approved" value={1} className="tab-heights" />
                    <Tab label="Rejected" value={3} className="tab-heights" />
                  </Tabs>
                )}

                {type === 5 && (
                  <Tabs
                    value={instantStatus}
                    onChange={(event, newStatus) => setInstantStatus(newStatus)}
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{
                      ml: 2,
                      "& .MuiTabs-indicator": {
                        backgroundColor: "primary.main",
                      },
                    }}
                  >
                    <Tab label="Upcoming" value={2} className="tab-heights" />
                    <Tab label="Completed" value={1} className="tab-heights" />
                    <Tab label="Cancelled" value={3} className="tab-heights" />
                  </Tabs>
                )}
                {paginatedData.length > 0 ? (
                  <ReusableTable
                    data={paginatedData}
                    title="Bookings"
                    headers={headers(
                      type,
                      page,
                      complementaryStatus,
                      instantStatus
                    )}
                    paginatedData={paginatedData}
                    handleOpenPopup={handleOpenPopup}
                    renderEditButton={renderCustomEditButton}
                    renderDeleteButton={renderCustomDeleteButton}
                    renderCustomViewButton={renderCustomViewButton}
                    renderResendPaymentButton={renderResendPaymentButton}
                    renderIndividualExportButton={renderIndividualExportButton}
                    renderPaymentUpdateButton={renderPaymentUpdateButton}
                    renderBookingUpdateButton={renderBookingUpdateButton}
                    noRecordsText="No records found"
                  />
                ) : (
                  <Box textAlign="center" py={5}>
                    <img
                      src={nodata}
                      alt="No Data"
                      style={{ maxWidth: "300px", maxHeight: "300px" }}
                    />
                  </Box>
                )}

                {filteredBookings.length > 0 && (
                  <Box mt={2} display="flex" justifyContent="end">
                    <Pagination
                      count={getTotalPages()}
                      page={Math.min(page, getTotalPages())}
                      onChange={handlePageChange}
                      color="primary"
                    />
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Dialog open={open} onClose={handleClosePopup} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
            Confirm Cancellation
          </DialogTitle>

          <DialogContent sx={{ p: 3 }}>
            <DialogContentText
              sx={{ mb: 2, textAlign: "center", fontSize: "16px" }}
            >
              Are you sure you want to cancel this booking? <br />
              <strong>Booking ID: {bookingToDelete?.booking_serial_no}</strong>
            </DialogContentText>

            <TextField
              autoFocus
              margin="dense"
              label="Reason for Cancellation"
              type="text"
              name="cancelReason"
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                },
              }}
            />
          </DialogContent>

          <DialogActions sx={{ justifyContent: "end", px: 3, pb: 3 }}>
            <Button
              size="medium"
              onClick={handleClosePopup}
              className="handle-back"
              variant="outlined"
              sx={{
                borderRadius: "8px",
                minWidth: "100px",
              }}
            >
              Cancel
            </Button>

            <CustomButton
              variant="contained"
              className="handle-delete"
              type="submit"
              size="medium"
              loading={deleteLoading}
              text="Confirm Cancel"
              onClick={handleConfirmDelete}
              disabled={!cancelReason.trim()}
              sx={{
                borderRadius: "8px",
                minWidth: "130px",
                backgroundColor: "#d32f2f",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
            />
          </DialogActions>
        </Dialog>

        <PaymentStatusDialog
          open={updatePaymentDialogOpen}
          onClose={handleClosePaymentDialog}
          title="Update Payment Status"
          selectedBooking={selectedBooking}
          handleUpdateStatus={handleUpdatePaymentStatus}
          loading={updatePaymentLoading}
          updateStatus={paymentStatus}
          setUpdateStatus={setPaymentStatus}
          setReferenceNumber={setReferenceNumber}
        />

        <PaymentStatusDialog
          open={updateBookingDialogOpen}
          onClose={handleCloseBookingStatusDialog}
          title="Update Booking Status"
          selectedBooking={selectedBooking}
          handleUpdateStatus={handleUpdateBookingStatus}
          loading={updateBookingLoading}
          updateStatus={bookingStatus}
          setUpdateStatus={setBookingStatus}
        />
      </Box>
    </>
  );
};
export default BookingList;

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Pagination,
//   Tabs,
//   Tab,
//   TextField,
//   Chip,
//   Select,
//   MenuItem,
//   Typography,
// } from "@mui/material";
// import ReusableTable from "../../component/ui/ReusableTable";
// import { saveAs } from "file-saver";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../../styles/Booking.scss";
// import "../../styles/UserStyles.css";
// import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";
// import {
//   formatDateWithAmPm,
//   formatDateWithAmPmBooking,
//   getStatusClass,
// } from "../../Style";
// import {
//   BOOKING_AIRPORT_DETAILS,
//   EDIT_BOOKINGS,
//   VIEW_BOOKINGS,
// } from "../../component/common/Routes/AppRoutes";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   VENDOR_BOOKING_AIRPORT_DETAILS,
//   VENDOR_EDIT_BOOKINGS,
//   VENDOR_VIEW_BOOKINGS,
// } from "../../component/common/Routes/VendorRoutes";
// import {
//   CUSTOMER_BOOKING_AIRPORT_DETAILS,
//   CUSTOMER_VIEW_BOOKINGS,
// } from "../../component/common/Routes/CustomerRoutes";
// import {
//   fetchBookingsRequest,
//   deleteBookingRequest,
//   fetchCustomerBookingsRequest,
//   resetBookingDetails,
//   fetchComplementaryBookingsRequest,
//   fetchInstantBookingsRequest,
//   getAllBookingsRequest,
//   fetchAllBookingRequest,
//   resendRazorpayLinkRequest,
//   resendRazorpayLinkReset,
//   updatePaymentStatusReset,
//   updatePaymentStatusRequest,
//   updateBookingStatusReset,
//   updateBookingStatusRequest,
// } from "../../redux/Bookings/BookingAction";

// import CustomButton from "../../component/ui/FormFields/Button";
// import { toast, ToastContainer } from "react-toastify";
// import Loading from "../../component/ui/Loading";
// import nodata from "../../assets/nodata.jpg";
// import axiosInstance from "../../redux/instance/AxiosInstance";
// import PaymentStatusDialog from "./PaymentStatusDialog";

// const BookingList = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//     const location = useLocation();

//   const bookings = useSelector((state) => state.booking.bookings || []);

//   const [updatePaymentDialogOpen, setUpdatePaymentDialogOpen] = useState(false);
//   const [updateBookingDialogOpen, setUpdateBookingDialogOpen] = useState(false);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState("1");
//   const [referenceNumber, setReferenceNumber] = useState("");
//   const [bookingStatus, setBookingStatus] = useState("1");

//   const bookingsForExport = useSelector(
//     (state) => state.booking.bookingsForExport || []
//   );

//   const totalRecord = useSelector((state) => state.booking?.totalRecords || []);
//   const totalPages = useSelector((state) => state.booking?.totalPages || []);
//   const deleteSuccess = useSelector((state) => state.booking?.message);
//   const { loading: viewListLoading, deleteLoading } = useSelector(
//     (state) => state.booking
//   );

//   const {
//     loading: resendPaymentLoading,
//     success: resendPaymentSuccess,
//     resendPaymentError,
//     data: resendPaymentData,
//   } = useSelector((state) => state.booking);

//   const { user } = useSelector((state) => state.auth);
//   const isStaff=user.role !== "Customer" && user.role !=="Vendor";
//     console.log("location",location)
//     const tab = location.state?.tab ?? isStaff? 0:2;
//     console.log("tab",tab);
//     const pageNumber= location.state?.page ?? 1;
//   const permissions = useMemo(() => {
//     let safePermissions = {};

//     try {
//       if (user?.permissions) {
//         safePermissions =
//           typeof user.permissions === "string"
//             ? JSON.parse(user.permissions)
//             : user.permissions;
//       }
//     } catch (error) {
//       safePermissions = {};
//     }

//     return safePermissions;
//   }, [user]);
//   const {
//     loading: updatePaymentLoading,
//     success: updatePaymentSuccess,
//     error: updatePaymentError,
//   } = useSelector((state) => state.booking.updatePaymentStatus || {});
//   const {
//     loading: updateBookingLoading,
//     success: updateBookingSuccess,
//     error: updateBookingError,
//   } = useSelector((state) => state.booking.updateBookingStatus || {});
//   const [type, setType] = useState(tab);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchColumn, setSearchColumn] = useState("");
//   const [open, setOpen] = useState(false);
//   const [bookingToDelete, setBookingToDelete] = useState(null);
//   const [page, setPage] = useState(pageNumber);
//   const [complementaryStatus, setComplementaryStatus] = useState(2);
//   const [instantStatus, setInstantStatus] = useState(2);
//   const currentDate = new Date().toISOString().split("T")[0];
//   const [cancelReason, setCancelReason] = useState("");
//   const [booked_type, setBooked_type] = useState(1);
//   const [allBookings, setAllBookings] = useState([]);
//   console.log("type",type);
//   // Add date filter states
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   const searchTimerRef = useRef(null);
//   const booking = useSelector((state) => state?.booking);

//   const paymentUrl = booking?.data?.payment_url;

//   const rowsPerPage = 10;
//   let bookingType = "upcoming";
//   if (type === 1) {
//     bookingType = "previous";
//   } else if (type === 3) {
//     bookingType = "cancelled";
//   } else if (type === 2) {
//     bookingType = "upcoming";
//   }

//   useEffect(() => {
//     return () => {
//       dispatch(resetBookingDetails());
//     };
//   }, []);

//   useEffect(() => {
//     if (resendPaymentSuccess) {
//       toast.success(resendPaymentData?.message, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resendRazorpayLinkReset());
//           fetchData();
//         },
//       });

//       if (user.customer_id && resendPaymentData?.payment_url) {
//         window.location.href = resendPaymentData.payment_url;
//       }
//     }
//     if (resendPaymentError) {
//       toast.error(`Failed to send payment link`, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resendRazorpayLinkReset());
//           fetchData();
//         },
//       });
//     }
//   }, [resendPaymentSuccess, resendPaymentError, dispatch]);

//   useEffect(() => {
//     if (updatePaymentSuccess) {
//       toast.success("Payment status updated successfully!", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updatePaymentStatusReset());
//           fetchData(page, type, searchQuery, searchColumn);
//           handleClosePaymentDialog();
//         },
//       });
//     }

//     if (updatePaymentError) {
//       toast.error(`Failed to update payment status: ${updatePaymentError}`, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updatePaymentStatusReset());
//         },
//       });
//     }
//   }, [updatePaymentSuccess, updatePaymentError]);
//   useEffect(() => {
//     if (updateBookingSuccess) {
//       toast.success("Booking status updated successfully!", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updateBookingStatusReset());
//           fetchData(page, type, searchQuery, searchColumn);
//           handleCloseBookingStatusDialog();
//         },
//       });
//     }

//     if (updateBookingError) {
//       toast.error(`Failed to update Booking status: ${updateBookingError}`, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updateBookingStatusReset());
//         },
//       });
//     }
//   }, [updateBookingSuccess, updateBookingError]);
//   const searchTimeoutRef = useRef(null);

//   const handleSearch = (query, column) => {
//     setSearchQuery(query);

//     if (column !== undefined) {
//       setSearchColumn(column);
//     }

//     if (searchTimerRef.current) {
//       clearTimeout(searchTimerRef.current);
//     }

//     if (query) {
//       searchTimerRef.current = setTimeout(() => {
//         setPage(1);
//         fetchData(1, type, query, column || searchColumn);
//       }, 1000);
//     } else if (query === "" && searchQuery !== "") {
//       searchTimerRef.current = setTimeout(() => {
//         setPage(1);
//         fetchData(1, type, query, column || searchColumn);
//       }, 1000);
//     }
//   };

//   // Add this useEffect for cleanup
//   useEffect(() => {
//     return () => {
//       if (searchTimerRef.current) {
//         clearTimeout(searchTimerRef.current);
//       }
//     };
//   }, []);

//   const handleColumnChange = (column) => {
//     setSearchColumn(column);
//   };

//   const fetchData = (
//     currentPage = page,
//     tabType = type,
//     search = searchQuery,
//     searchBy = searchColumn,
//     includeDates = false
//   ) => {
//     dispatch(resetBookingDetails());

//     // Calculate booked_type based on tabType
//     let bookedType = 1; // default
//     if (tabType === 1 || tabType === 2 || tabType === 3) {
//       bookedType = 1;
//     } else if (tabType === 4) {
//       bookedType = 2;
//     } else if (tabType === 5) {
//       bookedType = 3;
//     }

//     // Prepare date range parameters
//     const dateParams = {};
//     if (includeDates) {
//       if (fromDate) dateParams.from_date = fromDate;
//       if (toDate) dateParams.to_date = toDate;
//     }

//     if (user.role === "Customer" || user.role === "Vendor") {
//       dispatch(
//         fetchCustomerBookingsRequest({
//           customer_id: user.customer_id || "",
//           vendor_id: user.vendor_id || "",
//           pageNo: currentPage,
//           pageSize: rowsPerPage,
//           type:
//             tabType === 2
//               ? "upcoming"
//               : tabType === 1
//               ? "previous"
//               : tabType === 3
//               ? "cancelled"
//               : "upcoming",
//           booked_type: "all",
//           currentDate,
//           search: search || "",
//           search_by: searchBy || "",
//           ...dateParams, // Add date range to payload
//         })
//       );
//     } else {
//       if (tabType === 0) {
//         dispatch(
//           fetchAllBookingRequest({
//             pageNo: currentPage,
//             pagesize: rowsPerPage,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams, // Add date range to payload
//           })
//         );
//       } else if (tabType === 4) {
//         dispatch(
//           fetchComplementaryBookingsRequest({
//             pageNo: currentPage,
//             pagesize: rowsPerPage,
//             approove_status: complementaryStatus,
//             currentDate,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams, // Add date range to payload
//           })
//         );
//       } else if (tabType === 5) {
//         let instantBookingType;
//         switch (instantStatus) {
//           case 1:
//             instantBookingType = "previous";
//             break;
//           case 2:
//             instantBookingType = "upcoming";
//             break;
//           case 3:
//             instantBookingType = "cancelled";
//             break;
//           default:
//             instantBookingType = "upcoming";
//         }

//         dispatch(
//           fetchInstantBookingsRequest({
//             pageNo: currentPage,
//             pagesize: rowsPerPage,
//             type: instantBookingType,
//             currentDate,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams, // Add date range to payload
//           })
//         );
//       } else {
//         dispatch(
//           fetchBookingsRequest({
//             pageNo: currentPage,
//             pagesize: rowsPerPage,
//             type:
//               tabType === 2
//                 ? "upcoming"
//                 : tabType === 1
//                 ? "previous"
//                 : tabType === 3
//                 ? "cancelled"
//                 : "upcoming",
//             booked_type: bookedType,
//             currentDate,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams, // Add date range to payload
//           })
//         );
//       }
//     }
//   };

//   const handleDateFilterSubmit = () => {
//     setPage(1);
//     fetchData(1, type, searchQuery, searchColumn, true);
//   };

//   const handleClearDates = () => {
//     setFromDate("");
//     setToDate("");
//     setPage(1);
//     fetchData(1, type, searchQuery, searchColumn); // Fetch without dates
//   };

//   const isInitialLoad = useRef(true);
//   useEffect(() => {
//      console.log("srfgfsdgiuhfdguerhgeiurhgiuhgeuigheriughriugheiur")
//     if (isInitialLoad.current) {
//       dispatch(resetBookingDetails());
//       fetchData(1, type, "", "", "", "");
//       isInitialLoad.current = false;
//     } else {
//       // Reset page to 1 when changing tabs or status
//       const newPage = 1;
//       setPage(newPage);
//       fetchData(newPage, type, searchQuery, searchColumn, fromDate, toDate);
//     }
//   }, [type, complementaryStatus, instantStatus]);

//   useEffect(() => {
//     console.log("srfgfsdgiuhfdguerhgeiurhgiuhgeuigheriuefrwe4frerfewffwefwreuyfgewruywfgeruygferuygberuyghriugheiur")
//     if (!isInitialLoad.current) {
//       fetchData(page, type, searchQuery, searchColumn, fromDate, toDate);
//     }
//   }, [page]);

//   useEffect(() => {
//      console.log("srfgf eiur")
//     const processedData = preprocessData(bookings);
//     setAllBookings(processedData);
//   }, [bookings, searchQuery, searchColumn]);

//   const handleView = (booking) => {
//     const bookingId = booking?.booking_number;

//     if (permissions?.bookings?.view || user?.role === "Admin") {
//       navigate(`${VIEW_BOOKINGS.replace(":bookingId", bookingId)}`,{state:{tab:tab,page:page}});
//     } else if (user?.role === "Vendor") {
//       navigate(`${VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`,{state:{tab:tab,page:page}});
//     } else if (user?.role === "Customer") {
//       navigate(`${CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`,{state:{tab:tab,page:page}});
//     }
//   };

//   const handleEdit = (booking) => {
//     const bookingId = booking?.booking_number;
//     if (permissions?.bookings?.edit && user?.role === "Staff") {
//       navigate(`${EDIT_BOOKINGS.replace(":bookingId", bookingId)}`,{state:{tabEdit:tab,pageEdit:page}});
//     }
//     if (user?.role === "Admin") {
//       navigate(`${EDIT_BOOKINGS.replace(":bookingId", bookingId)}`, {
//         state: { bookingData: booking,tabEdit:tab,pageEdit:page },
//       });
//     }
//     if (user?.role === "Vendor") {
//       navigate(`${VENDOR_EDIT_BOOKINGS.replace(":bookingId", bookingId)}`, {
//         state: { bookingData: booking,tabEdit:tab,pageEdit:page },
//       });
//     }
//   };

//   const isFutureDate = (dateStr) => {
//     if (!dateStr || dateStr.trim().toLowerCase().includes("null")) return false;
//     const date = new Date(dateStr.trim());
//     return !isNaN(date.getTime()) && date.getTime() > new Date().getTime();
//   };

//   const shouldShowResendPaymentButton = (item) => {
//     const {
//       payment_status,
//       booked_type,
//       datetime_of_arrival,
//       datetime_of_departure,
//     } = item;
//     const isFutureArrivalOrDeparture =
//       isFutureDate(datetime_of_arrival) || isFutureDate(datetime_of_departure);

//     return (
//       (payment_status === 0 || payment_status === 2) &&
//       booked_type !== 2 &&
//       isFutureArrivalOrDeparture
//     );
//   };

//   const handleResendPayment = (booking) => {
//     const payload = {
//       customer_id: booking.customer_id || user.customer_id,
//       razorpay_order_id: booking.razorpay_order_id,
//     };

//     dispatch(resendRazorpayLinkRequest(payload));
//   };

//   const renderResendPaymentButton = (item) => {
//     if (!shouldShowResendPaymentButton(item)) return null;

//     return (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleResendPayment(item)}
//         className="orange-button"
//         disabled={resendPaymentLoading}
//       >
//         {resendPaymentLoading ? "SENDING..." : "RETRY"}
//       </Button>
//     );
//   };

//   const handleOpenPopup = (booking) => {
//     setBookingToDelete(booking);
//     setOpen(true);
//   };

//   const handleClosePopup = () => {
//     setBookingToDelete(null);
//     setOpen(false);
//   };

//   useEffect(() => {
//     if (deleteSuccess === "Your bookingservice cancelled") {
//       toast.success("Your bookingservice cancelled", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resetBookingDetails());
//           fetchData(page, type, searchQuery, searchColumn, fromDate, toDate);
//         },
//       });
//     }
//   }, [deleteSuccess]);

//   const filteredBookings = useMemo(() => {
//     if (!searchQuery) return allBookings;

//     return allBookings.filter((booking) => {
//       const bookingNumberMatch = booking.booking_serial_no
//         ?.toString()
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const bookingDateMatch = booking.date_of_booking
//         ?.toString()
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const bookedByMatch = booking.booked_user_name
//         ?.toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const bookedForMatch = booking.booked_for
//         ?.toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const serviceMatch = booking.service
//         ?.toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const serviceTypeMatch = booking.service_type_label
//         ?.toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const pnrMatch = booking.pnr_number
//         ?.toString()
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const arrivalFlightMatch = booking.arrival_flight_number
//         ?.toString()
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase());
//       const departureFlightMatch = booking.departure_flight_number
//         ?.toString()
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase());

//       // Return true if any field matches
//       return (
//         bookingNumberMatch ||
//         bookingDateMatch ||
//         bookedByMatch ||
//         bookedForMatch ||
//         serviceMatch ||
//         serviceTypeMatch ||
//         pnrMatch ||
//         arrivalFlightMatch ||
//         departureFlightMatch
//       );
//     });
//   }, [allBookings, searchQuery]);

//   const handleConfirmDelete = () => {
//     if (bookingToDelete) {
//       const bookingId = bookingToDelete.booking_number;
//       dispatch(deleteBookingRequest({ bookingId, cancel_notes: cancelReason }));
//     }
//     handleClosePopup();
//   };

//   // FIXED: Simplified handleTabChange
//   const handleTabChange = (event, newType) => {
//     setType(newType);
//     handleClearDates();
//     // Reset complementary and instant status when switching tabs
//     if (newType !== 4) {
//       setComplementaryStatus(2);
//     }
//     if (newType !== 5) {
//       setInstantStatus(2);
//     }
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleDateChange = (type, value) => {
//     if (type === "from") setFromDate(value);
//     if (type === "to") setToDate(value);

//     // Reset page to 1 and trigger fetch
//     setPage(1);
//     setTimeout(() => {
//       fetchData(1, type, searchQuery, searchColumn);
//     }, 100);
//   };

//   const handleIndividualExport = (booking) => {
//     try {
//       // Multiple ways to determine service type
//       const serviceTypeLabel = (booking.service_type_label || "").toLowerCase();
//       const serviceMode = (booking.service_mode || "").toLowerCase();
//       const service = (booking.service || "").toLowerCase();

//       // Check if this is a transit booking
//       const isTransit =
//         serviceTypeLabel.includes("transit") ||
//         serviceMode.includes("transit") ||
//         service.includes("transit");

//       // Check various fields to determine service type
//       const isDepartureByLabel =
//         serviceTypeLabel.includes("departure") ||
//         serviceMode.includes("departure") ||
//         service.includes("departure");

//       const isDepartureByData =
//         booking.datetime_of_departure &&
//         booking.datetime_of_departure !== "-" &&
//         booking.datetime_of_departure !== null;

//       const isArrivalByLabel =
//         serviceTypeLabel.includes("arrival") ||
//         serviceMode.includes("arrival") ||
//         service.includes("arrival");

//       const isArrivalByData =
//         booking.datetime_of_arrival &&
//         booking.datetime_of_arrival !== "-" &&
//         booking.datetime_of_arrival !== null;

//       // Determine final service type
//       let isDeparture = false;
//       let isArrival = false;

//       if (isTransit) {
//         // For transit, we need to show both arrival and departure info
//         isArrival = true;
//         isDeparture = true;
//       } else if (isDepartureByLabel) {
//         isDeparture = true;
//       } else if (isArrivalByLabel) {
//         isArrival = true;
//       } else if (isDepartureByData && !isArrivalByData) {
//         isDeparture = true;
//       } else if (isArrivalByData && !isDepartureByData) {
//         isArrival = true;
//       } else if (isArrivalByData) {
//         isArrival = true; // Default to arrival if both exist
//       }

//       const getAirportCity = () => {
//         if (isTransit) {
//           // For transit, show both arrival and departure cities
//           const arrivalCity = booking.arrival_city || "";
//           const departureCity = booking.departure_city || "";

//           if (arrivalCity && departureCity) {
//             return `Arrival: ${arrivalCity} | Departure: ${departureCity}`;
//           } else if (arrivalCity) {
//             return `Arrival: ${arrivalCity}`;
//           } else if (departureCity) {
//             return `Departure: ${departureCity}`;
//           }
//           // Fallback to airport_name if cities are not available
//           return booking.airport_name || "-";
//         } else if (isDeparture && booking.departure_city) {
//           return booking.departure_city;
//         } else if (isArrival && booking.arrival_city) {
//           return booking.arrival_city;
//         }
//         // Fallback: try both cities first, then airport_name
//         return (
//           booking.departure_city ||
//           booking.arrival_city ||
//           booking.airport_name ||
//           "-"
//         );
//       };

//       // Helper function to get service date
//       const getServiceDate = () => {
//         const cleanDate = (dateTime) => {
//           if (!dateTime || dateTime === "-") return null;
//           const dateStr = formatDateWithAmPm(dateTime).split(" ")[0];
//           // Remove any trailing comma or unwanted characters
//           return dateStr.replace(/[,\s]+$/, "").trim();
//         };

//         if (isTransit) {
//           // For transit, prioritize arrival date, then departure
//           const arrivalDate = cleanDate(booking.datetime_of_arrival);
//           if (arrivalDate) return arrivalDate;

//           const departureDate = cleanDate(booking.datetime_of_departure);
//           if (departureDate) return departureDate;
//         } else if (isDeparture) {
//           const departureDate = cleanDate(booking.datetime_of_departure);
//           if (departureDate) return departureDate;
//         } else if (isArrival) {
//           const arrivalDate = cleanDate(booking.datetime_of_arrival);
//           if (arrivalDate) return arrivalDate;
//         }

//         // Fallback: try both
//         const departureDate = cleanDate(booking.datetime_of_departure);
//         if (departureDate) return departureDate;

//         const arrivalDate = cleanDate(booking.datetime_of_arrival);
//         if (arrivalDate) return arrivalDate;

//         return "-";
//       };

//       // Helper function to get flight time
//       const getFlightTime = () => {
//         if (isTransit) {
//           // For transit, show both arrival and departure times
//           let arrivalTime = "";
//           let departureTime = "";

//           if (
//             booking.datetime_of_arrival &&
//             booking.datetime_of_arrival !== "-"
//           ) {
//             arrivalTime = formatDateWithAmPm(booking.datetime_of_arrival)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }

//           if (
//             booking.datetime_of_departure &&
//             booking.datetime_of_departure !== "-"
//           ) {
//             departureTime = formatDateWithAmPm(booking.datetime_of_departure)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }

//           if (arrivalTime && departureTime) {
//             return `Arrival: ${arrivalTime} | Departure: ${departureTime}`;
//           } else if (arrivalTime) {
//             return `Arrival: ${arrivalTime}`;
//           } else if (departureTime) {
//             return `Departure: ${departureTime}`;
//           }
//           return "-";
//         } else if (isDeparture) {
//           if (
//             booking.datetime_of_departure &&
//             booking.datetime_of_departure !== "-"
//           ) {
//             return formatDateWithAmPm(booking.datetime_of_departure)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }
//         } else if (isArrival) {
//           if (
//             booking.datetime_of_arrival &&
//             booking.datetime_of_arrival !== "-"
//           ) {
//             return formatDateWithAmPm(booking.datetime_of_arrival)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }
//         }
//         // Fallback: try both
//         if (
//           booking.datetime_of_departure &&
//           booking.datetime_of_departure !== "-"
//         ) {
//           return formatDateWithAmPm(booking.datetime_of_departure)
//             .split(" ")
//             .slice(1)
//             .join(" ");
//         }
//         if (
//           booking.datetime_of_arrival &&
//           booking.datetime_of_arrival !== "-"
//         ) {
//           return formatDateWithAmPm(booking.datetime_of_arrival)
//             .split(" ")
//             .slice(1)
//             .join(" ");
//         }
//         return "-";
//       };

//       // Helper function to get airline
//       const getAirline = () => {
//         if (isTransit) {
//           // For transit, show both airlines
//           const arrivalAirline = booking.arrival_airline || "";
//           const departureAirline = booking.departure_airline || "";

//           if (arrivalAirline && departureAirline) {
//             return `Arrival: ${arrivalAirline} | Departure: ${departureAirline}`;
//           } else if (arrivalAirline) {
//             return `Arrival: ${arrivalAirline}`;
//           } else if (departureAirline) {
//             return `Departure: ${departureAirline}`;
//           }
//           return "-";
//         } else if (isDeparture && booking.departure_airline) {
//           return booking.departure_airline;
//         } else if (isArrival && booking.arrival_airline) {
//           return booking.arrival_airline;
//         }
//         // Fallback: try both
//         return booking.departure_airline || booking.arrival_airline || "-";
//       };

//       // Helper function to get flight number
//       const getFlightNumber = () => {
//         if (isTransit) {
//           // For transit, show both flight numbers
//           const arrivalFlightNumber = booking.arrival_flight_number || "";
//           const departureFlightNumber = booking.departure_flight_number || "";

//           if (arrivalFlightNumber && departureFlightNumber) {
//             return `Arrival: ${arrivalFlightNumber} | Departure: ${departureFlightNumber}`;
//           } else if (arrivalFlightNumber) {
//             return `Arrival: ${arrivalFlightNumber}`;
//           } else if (departureFlightNumber) {
//             return `Departure: ${departureFlightNumber}`;
//           }
//           return "-";
//         } else if (isDeparture && booking.departure_flight_number) {
//           return booking.departure_flight_number;
//         } else if (isArrival && booking.arrival_flight_number) {
//           return booking.arrival_flight_number;
//         }
//         // Fallback: try both
//         return (
//           booking.departure_flight_number ||
//           booking.arrival_flight_number ||
//           "-"
//         );
//       };

//       // Helper function to get PNR
//       const getPNR = () => {
//         if (isTransit) {
//           // For transit, show both PNRs
//           const arrivalPNR = booking.arival_pnr_by_customer || "";
//           const departurePNR = booking.departure_pnr_by_customer || "";
//           const generalPNR = booking.pnr_number || "";

//           if (arrivalPNR && departurePNR) {
//             return `Arrival: ${arrivalPNR} | Departure: ${departurePNR}`;
//           } else if (arrivalPNR) {
//             return `Arrival: ${arrivalPNR}`;
//           } else if (departurePNR) {
//             return `Departure: ${departurePNR}`;
//           } else if (generalPNR) {
//             return generalPNR;
//           }
//           return "-";
//         } else if (isDeparture && booking.departure_pnr_by_customer) {
//           return booking.departure_pnr_by_customer;
//         } else if (isArrival && booking.arival_pnr_by_customer) {
//           return booking.arival_pnr_by_customer;
//         }
//         // Fallback: try all possibilities
//         return (
//           booking.departure_pnr_by_customer ||
//           booking.arival_pnr_by_customer ||
//           booking.pnr_number ||
//           "-"
//         );
//       };

//       // Create CSV content with proper formatting for Excel alignment
//       const csvRows = [
//         ["Guest Name", `\t${booking.booked_for || "-"}`],
//         ["Placard Guest Name", `\t${booking.booked_for || "-"}`],
//         [
//           "Guest Contact No.",
//           (booking?.contact || "-") +
//             " / " +
//             (booking?.emergency_contact || "-"),
//         ],
//         ["No. of Pax", `\t${booking.total_passenger || "1"}`],
//         ["Service Date", `\t${getServiceDate()}`],
//         ["Airport", `\t${getAirportCity() || "-"}`],
//         ["Terminal", `\t${booking.service_types || "-"}`],
//         ["Service Type", `\t${booking.service || "-"}`],
//         ["Service Mode", `\t${booking.service_type_label || "-"}`],
//         ["Airline", `\t${getAirline()}`],
//         ["Flight Number", `\t${getFlightNumber()}`],
//         ["Flight Time", `\t${getFlightTime()}`],
//         ["PNR No.", `\t${getPNR()}`],
//         ["Remarks", `\t${booking.notes || "-"}`],
//       ];

//       // Convert to CSV format with proper escaping
//       const csvContent = csvRows
//         .map((row) =>
//           row
//             .map((field) => {
//               // Convert field to string and handle special characters
//               let stringField = String(field || "");

//               // For Excel alignment, we can use specific formatting
//               if (
//                 stringField.includes(",") ||
//                 stringField.includes('"') ||
//                 stringField.includes("\n") ||
//                 stringField.includes("\t")
//               ) {
//                 // Escape quotes and wrap in quotes
//                 return `"${stringField.replace(/"/g, '""')}"`;
//               }
//               return stringField;
//             })
//             .join(",")
//         )
//         .join("\n");

//       // Add UTF-8 BOM to fix encoding issues
//       const BOM = "\uFEFF";
//       const csvWithBOM = BOM + csvContent;

//       // Create and download the file
//       const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
//       const fileName = `booking_${booking.booking_serial_no}.csv`;
//       saveAs(blob, fileName);

//       // toast.success("Booking details exported successfully!", {
//       //   position: "top-center",
//       //   autoClose: 2000,
//       // });
//     } catch (error) {
//       toast.error("Failed to export booking details", {
//         position: "top-center",
//         autoClose: 3000,
//       });
//     }
//   };
//   // NEW: Render individual export button (only for Admin and Staff)
//   const renderIndividualExportButton = (item) => {
//     if (user?.role !== "Admin" && user?.role !== "Staff") {
//       return null;
//     }

//     return (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleIndividualExport(item)}
//         className="orange-button"
//       >
//         EXPORT
//       </Button>
//     );
//   };
//   const handleExport = () => {
//     let apiParams = {
//       pagination_required: false,
//     };
//     if (fromDate) apiParams.from_date = fromDate;
//     if (toDate) apiParams.to_date = toDate;
//     if (type === 0) {
//       apiParams = {
//         ...apiParams,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     } else if (type === 4) {
//       apiParams = {
//         ...apiParams,
//         approove_status: complementaryStatus,
//         booked_type: 2,
//         currentDate,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     } else if (type === 5) {
//       let instantBookingType;
//       switch (instantStatus) {
//         case 1:
//           instantBookingType = "previous";
//           break;
//         case 2:
//           instantBookingType = "upcoming";
//           break;
//         case 3:
//           instantBookingType = "cancelled";
//           break;
//         default:
//           instantBookingType = "upcoming";
//       }

//       apiParams = {
//         ...apiParams,
//         type: instantBookingType,
//         booked_type: 3,
//         currentDate,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     } else {
//       apiParams = {
//         ...apiParams,
//         type: type === 2 ? "upcoming" : type === 1 ? "previous" : "cancelled",
//         booked_type: booked_type,
//         currentDate,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     }

//     let apiCall;

//     if (user.role === "Customer" || user.role === "Vendor") {
//       apiCall = axiosInstance.get("/bookservice/bookinggetbycustomer", {
//         params: {
//           ...apiParams,
//           customer_id: user.customer_id || "",
//           vendor_id: user.vendor_id || "",
//           booked_type: "all",
//         },
//       });
//     } else {
//       let endpoint;
//       if (type === 0) {
//         endpoint = "bookservice/servicebookingalldata";
//       } else if (type === 4) {
//         endpoint = "bookservice/complementrybookingservice";
//       } else if (type === 5) {
//         endpoint = "bookservice/list";
//       } else {
//         endpoint = "/bookservice/list";
//       }

//       apiCall = axiosInstance.get(endpoint, { params: apiParams });
//     }

//     apiCall
//       .then((response) => {
//         let bookingsData = response?.data?.data || [];

//         const processedData = preprocessData(bookingsData);

//         const csvHeaders = [
//           "Booking Number",
//           "Booking Date",
//           "Booked User Name",
//           "Booked For",
//           "Airport Name",
//           "Airport Type",
//           "First Name",
//           "Last Name",
//           "Company Name",
//           "No Of Adult",
//           "No Of Child",
//           "No Of Infant",
//           "Total Passenger",
//           "Service",
//           "Service Type",
//           "Notes",
//           "Arrival Date/Time",
//           "Arrival City",
//           "Arrival Airline",
//           "Arrival Flight Number",
//           "Arrival PNR By Customer",
//           "Departure Date/Time",
//           "Departure City",
//           "Departure Airline",
//           "Departure Flight Number",
//           "Departure PNR By Customer",
//           "Payment Reference Number",
//           "Payment Status",
//           "Approval Status",
//           "Booked Type",
//         ];
//         const csvRows = processedData.map((booking) => {
//           const escapeCsvField = (field) => {
//             if (field === null || field === undefined) return '""';
//             const stringField = String(field || "-");
//             if (
//               stringField.includes(",") ||
//               stringField.includes('"') ||
//               stringField.includes("\n")
//             ) {
//               return `"${stringField.replace(/"/g, '""')}"`;
//             }
//             return stringField;
//           };

//           const getApprovalStatusText = (statusCode) => {
//             if (statusCode === 1 || statusCode === "1") return "Approved";
//             if (statusCode === 2 || statusCode === "2") return "Pending";
//             if (statusCode === 3 || statusCode === "3") return "Rejected";
//             return statusCode || "";
//           };

//           const getPaymentStatusText = (statusCode, bookedType) => {
//             if (statusCode === 1) return "Completed";
//             if (statusCode === 0 && bookedType === 2)
//               return "Free (Complementary)";
//             if (statusCode === 0) return "Pending";
//             if (statusCode === 2) return "Failed";
//             if (statusCode === 3) return "Refunded";
//             return "Aborted";
//           };

//           const getBookedTypeLabel = (typeCode) => {
//             switch (typeCode) {
//               case 1:
//                 return "Regular";
//               case 2:
//                 return "Complementary";
//               case 3:
//                 return "Instant Booking";
//               default:
//                 return typeCode || "";
//             }
//           };

//           const approvalStatus = booking.approove_status;
//           const approvalStatusText = getApprovalStatusText(approvalStatus);
//           const paymentStatusText = getPaymentStatusText(
//             booking.payment_status,
//             booking.booked_type
//           );

//           return [
//             escapeCsvField(booking.booking_serial_no),
//             escapeCsvField(formatDateWithAmPm(booking.date_of_booking)),
//             escapeCsvField(booking.booked_user_name),
//             escapeCsvField(booking.booked_for),
//             escapeCsvField(booking.airport_name),
//             escapeCsvField(booking.airport_type),
//             escapeCsvField(booking.first_name),
//             escapeCsvField(booking.last_name),
//             escapeCsvField(booking.company_name),
//             escapeCsvField(booking.number_of_adults),
//             escapeCsvField(booking.number_of_child),
//             escapeCsvField(booking.number_of_infant),
//             escapeCsvField(booking.total_passenger),
//             escapeCsvField(booking.service),
//             escapeCsvField(booking.service_type_label),
//             escapeCsvField(booking.notes),
//             escapeCsvField(formatDateWithAmPm(booking.datetime_of_arrival)),
//             escapeCsvField(booking.arrival_city),
//             escapeCsvField(booking.arrival_airline),
//             escapeCsvField(booking.arrival_flight_number),
//             escapeCsvField(booking.arival_pnr_by_customer),
//             escapeCsvField(formatDateWithAmPm(booking.datetime_of_departure)),
//             escapeCsvField(booking.departure_city),
//             escapeCsvField(booking.departure_airline),
//             escapeCsvField(booking.departure_flight_number),
//             escapeCsvField(booking.departure_pnr_by_customer),
//             escapeCsvField(booking.pnr_number),
//             escapeCsvField(paymentStatusText),
//             escapeCsvField(approvalStatusText),
//             escapeCsvField(getBookedTypeLabel(booking.booked_type)),
//           ].join(",");
//         });
//         const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
//         const blob = new Blob([csvContent], {
//           type: "text/csv;charset=utf-8;",
//         });
//         saveAs(blob, `bookings_${new Date().toISOString().split("T")[0]}.csv`);
//       })
//       .catch((error) => {});
//   };
//   const preprocessData = (data) => {
//     if (!data || !Array.isArray(data) || data.length === 0) {
//       return [];
//     }

//     const data1 = data.map((item) => {
//       const item1 = item?.BookingDetail;
//       return { item1 };
//     });
//     return data.map((item) => {

//       const bookingUpdateLogs = item?.bookingUpdateLogs || [];
//       if (
//         !Array.isArray(bookingUpdateLogs) &&
//         typeof bookingUpdateLogs === "object"
//       ) {
//         bookingUpdateLogs = [bookingUpdateLogs];
//       }

//       // Get the first log if exists
//       const latestLog =
//         bookingUpdateLogs.length > 0 ? bookingUpdateLogs[0] : null;
//       const bookingDetail = item.BookingDetail || {};
//       const billingAddress = item.BillingAddress || {};
//       const customerContact = item?.Customer?.phone || {};
//       const service = item.Service.type_of_service || {};
//       const order = item.Order || {};
//       const numberOfAdults = bookingDetail.number_of_adults || 0;
//       const numberOfChildren = bookingDetail.number_of_child || 0;
//       const numberOfInfants = bookingDetail.number_of_infant || 0;
//       const totalPassengers =
//         numberOfAdults + numberOfChildren + numberOfInfants;
//       const bookedUser = bookingDetail["BookedUser"] || {};
//       let bookedUserName = "-";

//       const user_type = bookedUser?.user_type || 0;

//       if (user_type === 3 && bookedUser?.Customer) {
//         bookedUserName = bookedUser?.Customer?.full_name;
//       } else if (user_type === 2 && bookedUser?.Vendor) {
//         bookedUserName = bookedUser?.Vendor?.full_name;
//       } else if (user_type === 4 && bookedUser?.Staff) {
//         bookedUserName = bookedUser?.Staff?.full_name;
//       } else {
//         bookedUserName = `${bookedUser?.first_name || ""} ${
//           bookedUser?.last_name || ""
//         }`.trim();
//       }

//       return {
//         booking_number: item.id || "-",
//         booking_serial_no: item.booking_serial_no || "",
//         date_of_booking: item.created_at ? item.created_at : "-",
//         booked_user_name: bookedUserName,
//         booked_for: item?.bookingFamilies?.[0]?.familyMember?.first_name,
//         pnr_number: item?.pnr_number,
//         airport_name: item?.Airport?.name || "-",
//         airport_type: item?.Airport?.airport_type || "-",
//         first_name: billingAddress.first_name || "-",
//         last_name: billingAddress.last_name || "-",
//         company_name: billingAddress.company_name || "-",
//         number_of_adults: numberOfAdults || "-",
//         number_of_child: numberOfChildren || "-",
//         number_of_infant: numberOfInfants || "-",
//         total_passenger: totalPassengers,
//         service: item.Service?.services || order.service || "-",
//         service_type_label:
//           { 1: "Arrival", 2: "Departure", 3: "Transit" }[item.service_type] ||
//           "-",
//         notes: bookingDetail.notes || "-",
//         datetime_of_arrival:
//           bookingDetail?.date_of_arrival != "2000-01-01"
//             ? ` ${bookingDetail?.date_of_arrival} ${bookingDetail?.time_of_arrival} `
//             : "-",
//         datetime_of_departure:
//           bookingDetail?.date_of_departure != "2000-01-01"
//             ? ` ${bookingDetail?.date_of_departure} ${bookingDetail?.time_of_departure} `
//             : "-",
//         arrival_city:
//           item?.Service.type_of_name === "arrival"
//             ? item.Airport?.name
//             : bookingDetail.arrival_from_city || "-",

//         arrival_airline: bookingDetail.arrival_airlines || "-",
//         arrival_flight_number: bookingDetail.arrival_flight_number || "-",
//         arival_pnr_by_customer: item?.arival_pnr_by_customer || "-",
//         departure_city:
//           item?.Service.type_of_name === "departure"
//             ? item.Airport?.name
//             : bookingDetail.departure_from_city || "-",

//         departure_airline: bookingDetail.departure_airlines || "-",
//         departure_flight_number: bookingDetail.departure_flight_number || "-",
//         departure_pnr_by_customer: item?.departure_pnr_by_customer || "-",
//         payment_status: item?.payment_status || 0,
//         approove_status: item.approove_status,
//         booked_type: item.booked_type,
//         user_type: user_type,
//         contact: customerContact,
//         emergency_contact: billingAddress?.emergency_contact,
//         service_types: service,
//         staff_update_status: latestLog ? latestLog.staff_update_status : null,
//         booking_status_update_by: latestLog?.Staff?.full_name||"-",
//         // Add additional fields for resend payment functionality
//         customer_id: item?.customer_id,
//         razorpay_order_id: item?.razorpay_order_id || item?.pnr_number,
//       };
//     });
//   };
//   if (viewListLoading) {
//     return <Loading text="Loading Booking Details..." />;
//   }

//   const paginatedData = filteredBookings;

//   const headers = [
//     {
//       field: "booking_serial_no",
//       header: "Booking Number",

//       isClickable: true,
//       onClick: (row) => {
//         const bookingId = row.booking_number;
//         if (permissions?.bookings?.view || user?.role === "Admin") {
//           return `${VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
//         } else if (user?.role === "Vendor") {
//           return `${VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
//         } else if (user?.role === "Customer") {
//           return `${CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
//         }
//       },
//     },

//     {
//       field: "date_of_booking",
//       header: "Booking Date",
//       render: (value) => (value ? formatDateWithAmPm(value) : "-"),
//     },
//     {
//       field: "booked_user_name",
//       header: "Booked By",

//       render: (value, row) => {
//         // if (row.user_type === 1) {
//         //   return <span className="badge admin-badge">{value} (Admin)</span>;
//         // } else
//         if (row.user_type === 2) {
//           return <span className="badge vendor-badge">{value} (Vendor)</span>;
//         } else if (row.user_type === 3) {
//           return (
//             <span className="badge customer-badge">{value} (Customer)</span>
//           );
//         }
//         return value;
//       },
//       isClickable: true,
//       onClick: (row) => {
//         const bookingId = row.booking_number;
//         if (permissions?.bookings?.view || user?.role === "Admin") {
//           return `${VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
//         } else if (user?.role === "Vendor") {
//           return `${VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
//         } else if (user?.role === "Customer") {
//           return `${CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId)}`;
//         }
//       },
//     },
//     { field: "booked_for", header: "Booked For" },
//     { field: "number_of_adults", header: "No of Adults" },
//     { field: "number_of_child", header: "No of Children" },
//     { field: "number_of_infant", header: "No of Infants" },
//     { field: "total_passenger", header: "Total Passengers" },
//     { field: "service", header: "Service" },
//     { field: "service_type_label", header: "Service Type" },
//     {
//       field: "datetime_of_arrival",
//       header: "Arrival Date/Time",
//       render: (value) => (value ? formatDateWithAmPmBooking(value) : "-"),
//     },
//     { field: "arrival_city", header: "Arrival City" },
//     { field: "arrival_airline", header: "Arrival Airline" },
//     {
//       field: "arrival_flight_number",
//       header: "Arrival Flight Number",
//     },
//     {
//       field: "arival_pnr_by_customer",
//       header: "Arrival PNR Number",
//     },
//     {
//       field: "datetime_of_departure",
//       header: "Departure Date/Time",
//       render: (value) => {
//         return value ? formatDateWithAmPmBooking(value) : "-";
//       },
//     },

//     { field: "departure_city", header: "Departure City" },
//     { field: "departure_airline", header: "Departure Airline" },
//     {
//       field: "departure_flight_number",
//       header: "Departure Flight Number",
//     },
//     {
//       field: "departure_pnr_by_customer",
//       header: "Departure PNR Number",
//     },
//     { field: "pnr_number", header: "Payment Reference Number" },

//     {
//       field: "payment_status",
//       header: "Payment Status",
//       render: (value, row) => {
//         return (
//           <Chip
//             label={
//               value === 1
//                 ? "Completed"
//                 : value === 0 && row?.booked_type === 2
//                 ? `Free
//                       (Complementary)
//                     `
//                 : value === 0
//                 ? `pending
//                     `
//                 : value === 2
//                 ? "Failed"
//                 : value === 3
//                 ? "Refunded"
//                 : "Aborted"
//             }
//             color={
//               value === 1
//                 ? "success"
//                 : value === 0 && row?.booked_type === 2
//                 ? "success"
//                 : value === 2
//                 ? "error"
//                 : value === 3
//                 ? "success"
//                 : value === 0
//                 ? "warning"
//                 : "error"
//             }
//             size="small"
//           />
//         );
//       },
//     },

// ...(user?.user_type !== 2 && user?.user_type !== 3
//   ? [
//       {
//         field: "staff_update_status",
//         header: "Booking Status",
//         render: (value) => {
//           if (value === undefined || value === null) return "-";

//           const statusMap = {
//             1: { label: "Pending", color: "warning" },
//             2: { label: "Processing", color: "warning" },
//             3: { label: "Completed", color: "success" },
//             4: { label: "Cancelled", color: "error" },
//           };

//           return (
//             <Chip
//               label={statusMap[value]?.label || "-"}
//               color={statusMap[value]?.color || "default"}
//               size="small"
//             />
//           );
//         },
//       },
//       { field: "booking_status_update_by", header: "Updated By" },
//     ]
//   : []),

//     { field: "notes", header: "Notes" },
//   ];

//   const bookingFilterHeaders = [
//     { value: "booking_serial_no", label: "Booking Number" },
//     { value: "date_of_booking", label: "Booking Date" },
//     { value: "booked_user_name", label: "Booked By" },
//     { value: "booked_for", label: "Booked For" },
//     { value: "service", label: "Service" },
//     { value: "service_type_label", label: "Service Type" },
//   ];

//   const renderCustomDeleteButton = (item) => {
//     if (type === 3 || type === 1) {
//       return null;
//     }
//     return (
//       (user?.user_type !== 1 && user?.user_type !== 2
//         ? permissions?.bookings?.edit ||
//           user?.user_type === 1 ||
//           user?.user_type === 2
//         : user?.user_type === 1) && (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleOpenPopup(item)}
//           className="grey-button"
//         >
//           CANCEL
//         </Button>
//       )
//     );
//   };

//   const renderCustomEditButton = (item) => {
//     if (type === 3 || type === 1) return null;

//     const isFutureDate = (dateString) => {
//       if (!dateString || dateString === "-" || dateString === "2000-01-01") {
//         return false;
//       }
//       const datePart = dateString.trim().split(" ")[0];
//       const itemDate = new Date(datePart);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       itemDate.setHours(0, 0, 0, 0);

//       return itemDate > today;
//     };
//     const arrivalIsFuture = isFutureDate(item.datetime_of_arrival);
//     const departureIsFuture = isFutureDate(item.datetime_of_departure);

//     const canEdit = arrivalIsFuture || departureIsFuture;

//     const hasPermission =
//       user?.user_type !== 1 && user?.user_type !== 2
//         ? permissions?.bookings?.edit ||
//           user?.user_type === 1 ||
//           user?.user_type === 2
//         : user?.user_type === 1 || user?.user_type === 2;

//     return (
//       hasPermission &&
//       canEdit && (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleEdit(item)}
//           className="orange-button"
//         >
//           EDIT
//         </Button>
//       )
//     );
//   };
//   const renderCustomViewButton = (item) =>
//     (user?.user_type !== 1 && user?.user_type !== 2 && user?.user_type !== 3
//       ? permissions?.bookings?.view ||
//         user?.user_type === 1 ||
//         user?.user_type === 2
//       : user?.user_type === 1 ||
//         user?.user_type === 2 ||
//         user?.user_type === 3) && (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleView(item)}
//         className="grey-button"
//       >
//         VIEW
//       </Button>
//     );

//   const getTotalPages = () => {
//     return Math.max(1, Math.ceil(totalRecord / rowsPerPage));
//   };
//   // Open payment update dialog
//   const handleOpenPaymentUpdate = (booking) => {
//     setSelectedBooking(booking);

//     setPaymentStatus(String(booking.payment_status || "1"));
//     setUpdatePaymentDialogOpen(true);
//   };

//   // Close dialog and reset
//   const handleClosePaymentDialog = () => {
//     setUpdatePaymentDialogOpen(false);
//     setSelectedBooking(null);
//     // if (updatePaymentSuccess || updatePaymentError) {
//     //   dispatch(updatePaymentStatusReset());
//     // }
//   };

//   // Submit payment status update
//   const handleUpdatePaymentStatus = () => {
//     if (!selectedBooking) return;

//     const payload = {
//       booking_id: selectedBooking.booking_number,
//       payment_status: paymentStatus,
//       payment_refrence_number: referenceNumber,
//     };

//     dispatch(updatePaymentStatusRequest(payload));
//   };
//   // Open payment update dialog
//   const handleOpenBookingStatusUpdate = (booking) => {
//     setSelectedBooking(booking);
//     setPaymentStatus(String(booking.payment_status || "1"));
//     setUpdateBookingDialogOpen(true);
//   };

//   // Close dialog and reset
//   const handleCloseBookingStatusDialog = () => {
//     setUpdateBookingDialogOpen(false);
//     setSelectedBooking(null);
//     if (updatePaymentSuccess || updatePaymentError) {
//       dispatch(updateBookingStatusReset());
//     }
//   };

//   const handleUpdateBookingStatus = () => {
//     if (!selectedBooking) return;

//     const payload = {
//       booking_id: selectedBooking.booking_number,
//       staff_update_status: bookingStatus,
//     };

//     dispatch(updateBookingStatusRequest(payload));
//   };
//   const renderPaymentUpdateButton = (item) =>
//     (["Admin"].includes(user?.role) ||
//       ["Manager"].includes(user?.role_name)) && (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleOpenPaymentUpdate(item)}
//         className="grey-button"
//         sx={{ width: "130px" }}
//       >
//         UPDATE STATUS
//       </Button>
//     );
//   const renderBookingUpdateButton = (item) => (
//     <Button
//       variant="outlined"
//       size="small"
//       onClick={() => handleOpenBookingStatusUpdate(item)}
//       className="orange-button"
//       sx={{ width: "150px" }}
//     >
//       BOOKING STATUS
//     </Button>
//   );
//   return (
//     <>
//       <ToastContainer />
//       <Box className="container">
//         <Grid container spacing={5}>
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <SearchAndButtonTab
//                   title="Bookings"
//                   columns={bookingFilterHeaders}
//                   searchColumn={searchColumn}
//                   hideSearchColumnSelector={true}
//                   setSearchColumn={handleColumnChange}
//                   searchQuery={searchQuery}
//                   setSearchQuery={handleSearch}
//                   handleExport={handleExport}
//                   routeName={
//                     user.role === "Vendor"
//                       ? VENDOR_BOOKING_AIRPORT_DETAILS
//                       : user.role === "Customer"
//                       ? CUSTOMER_BOOKING_AIRPORT_DETAILS
//                       : BOOKING_AIRPORT_DETAILS
//                   }
//                   permissions={permissions}
//                   user={user}
//                 />
//                 {(user?.role === "Admin" || user?.role === "Staff") && (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       gap: 2,
//                       mb: 2,
//                       alignItems: "center",
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <TextField
//                       label="From Date"
//                       type="date"
//                       value={fromDate}
//                       onChange={(e) => setFromDate(e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                       sx={{ minWidth: 180 }}
//                       inputProps={{ max: toDate || currentDate }}
//                     />
//                     <TextField
//                       label="To Date"
//                       type="date"
//                       value={toDate}
//                       onChange={(e) => setToDate(e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                       sx={{ minWidth: 180 }}
//                       inputProps={{
//                         min: fromDate,
//                         max: currentDate,
//                       }}
//                     />

//                     <Button
//                       variant="contained"
//                       onClick={handleDateFilterSubmit}
//                       disabled={!fromDate && !toDate}
//                       className="orange-button"
//                     >
//                       Apply Dates
//                     </Button>

//                     <Button
//                       variant="outlined"
//                       onClick={handleClearDates}
//                       disabled={!fromDate && !toDate}
//                       className="grey-button"
//                     >
//                       Clear Dates
//                     </Button>
//                   </Box>
//                 )}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Tabs
//                     value={type}
//                     onChange={handleTabChange}
//                     indicatorColor="primary"
//                     textColor="primary"
//                   >
//                     {user.role !== "Customer" && user.role !== "Vendor" && (
//                       <Tab label="All" value={0} />
//                     )}
//                     <Tab label="Upcoming" value={2} />
//                     <Tab label="Completed" value={1} />
//                     <Tab label="Cancelled" value={3} />
//                     {user.role !== "Customer" && user.role !== "Vendor" && (
//                       <Tab label="Complementary" value={4} />
//                     )}
//                     {user.role !== "Customer" && user.role !== "Vendor" && (
//                       <Tab label="Instant Booking" value={5} />
//                     )}
//                   </Tabs>
//                 </Box>

//                 {type === 4 && (
//                   <Tabs
//                     value={complementaryStatus}
//                     onChange={(event, newStatus) =>
//                       setComplementaryStatus(newStatus)
//                     }
//                     indicatorColor="primary"
//                     textColor="primary"
//                     sx={{
//                       ml: 2,
//                       "& .MuiTabs-indicator": {
//                         backgroundColor: "primary.main",
//                       },
//                     }}
//                   >
//                     <Tab label="Pending" value={2} className="tab-heights" />
//                     <Tab label="Approved" value={1} className="tab-heights" />
//                     <Tab label="Rejected" value={3} className="tab-heights" />
//                   </Tabs>
//                 )}

//                 {type === 5 && (
//                   <Tabs
//                     value={instantStatus}
//                     onChange={(event, newStatus) => setInstantStatus(newStatus)}
//                     indicatorColor="primary"
//                     textColor="primary"
//                     sx={{
//                       ml: 2,
//                       "& .MuiTabs-indicator": {
//                         backgroundColor: "primary.main",
//                       },
//                     }}
//                   >
//                     <Tab label="Upcoming" value={2} className="tab-heights" />
//                     <Tab label="Completed" value={1} className="tab-heights" />
//                     <Tab label="Cancelled" value={3} className="tab-heights" />
//                   </Tabs>
//                 )}
//                 {paginatedData.length > 0 ? (
//                   <ReusableTable
//                     data={paginatedData}
//                     title="Bookings"
//                     headers={headers}
//                     paginatedData={paginatedData}
//                     handleOpenPopup={handleOpenPopup}
//                     renderEditButton={renderCustomEditButton}
//                     renderDeleteButton={renderCustomDeleteButton}
//                     renderCustomViewButton={renderCustomViewButton}
//                     renderResendPaymentButton={renderResendPaymentButton}
//                     renderIndividualExportButton={renderIndividualExportButton}
//                     renderPaymentUpdateButton={renderPaymentUpdateButton}
//                     renderBookingUpdateButton={renderBookingUpdateButton}
//                     noRecordsText="No records found"
//                   />
//                 ) : (
//                   <Box textAlign="center" py={5}>
//                     <img
//                       src={nodata}
//                       alt="No Data"
//                       style={{ maxWidth: "300px", maxHeight: "300px" }}
//                     />
//                   </Box>
//                 )}

//                 {filteredBookings.length > 0 && (
//                   <Box mt={2} display="flex" justifyContent="end">
//                     <Pagination
//                       count={getTotalPages()}
//                       page={Math.min(page, getTotalPages())}
//                       onChange={handlePageChange}
//                       color="primary"
//                     />
//                   </Box>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//         <Dialog open={open} onClose={handleClosePopup} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
//             Confirm Cancellation
//           </DialogTitle>

//           <DialogContent sx={{ p: 3 }}>
//             <DialogContentText
//               sx={{ mb: 2, textAlign: "center", fontSize: "16px" }}
//             >
//               Are you sure you want to cancel this booking? <br />
//               <strong>Booking ID: {bookingToDelete?.booking_serial_no}</strong>
//             </DialogContentText>

//             <TextField
//               autoFocus
//               margin="dense"
//               label="Reason for Cancellation"
//               type="text"
//               name="cancelReason"
//               fullWidth
//               multiline
//               rows={4}
//               variant="outlined"
//               value={cancelReason}
//               onChange={(e) => setCancelReason(e.target.value)}
//               required
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "10px",
//                 },
//               }}
//             />
//           </DialogContent>

//           <DialogActions sx={{ justifyContent: "end", px: 3, pb: 3 }}>
//             <Button
//               size="medium"
//               onClick={handleClosePopup}
//               className="handle-back"
//               variant="outlined"
//               sx={{
//                 borderRadius: "8px",
//                 minWidth: "100px",
//               }}
//             >
//               Cancel
//             </Button>

//             <CustomButton
//               variant="contained"
//               className="handle-delete"
//               type="submit"
//               size="medium"
//               loading={deleteLoading}
//               text="Confirm Cancel"
//               onClick={handleConfirmDelete}
//               disabled={!cancelReason.trim()}
//               sx={{
//                 borderRadius: "8px",
//                 minWidth: "130px",
//                 backgroundColor: "#d32f2f",
//                 "&:hover": {
//                   backgroundColor: "#b71c1c",
//                 },
//               }}
//             />
//           </DialogActions>
//         </Dialog>

//         <PaymentStatusDialog
//           open={updatePaymentDialogOpen}
//           onClose={handleClosePaymentDialog}
//           title="Update Payment Status"
//           selectedBooking={selectedBooking}
//           handleUpdateStatus={handleUpdatePaymentStatus}
//           loading={updatePaymentLoading}
//           updateStatus={paymentStatus}
//           setUpdateStatus={setPaymentStatus}
//           setReferenceNumber={setReferenceNumber}
//         />

//         <PaymentStatusDialog
//           open={updateBookingDialogOpen}
//           onClose={handleCloseBookingStatusDialog}
//           title="Update Booking Status"
//           selectedBooking={selectedBooking}
//           handleUpdateStatus={handleUpdateBookingStatus}
//           loading={updateBookingLoading}
//           updateStatus={bookingStatus}
//           setUpdateStatus={setBookingStatus}
//         />
//       </Box>
//     </>
//   );
// };
// export default BookingList;
